/** Modern Standard Arabic. Pending native-speaker review (PLAN Q-I1). */
export const ar = {
    'brand.name': 'beinstore',
    'email.footer.automated': 'أُرسلت هذه الرسالة تلقائيًا من {brand}. يُرجى عدم الرد عليها.',
    'email.signInCode.subject': 'رمز الدخول إلى {brand}: {code}',
    'email.signInCode.heading': 'رمز الدخول الخاص بك',
    'email.signInCode.intro': 'استخدم هذا الرمز لتسجيل الدخول إلى {brand}:',
    'email.signInCode.expiry': 'تنتهي صلاحيته بعد {minutes, plural, zero {# دقيقة} one {دقيقة واحدة} two {دقيقتين} few {# دقائق} many {# دقيقة} other {# دقيقة}} ولا يمكن استخدامه إلا مرة واحدة.',
    'email.signInCode.ignore': 'إذا لم تطلب هذا الرمز فتجاهل هذه الرسالة: لا يمكن لأحد تسجيل الدخول بدونه.',
    'email.signInCode.neverShare': 'لن يطلب منك فريق {brand} هذا الرمز أبدًا.',
    'email.order.subject': 'تم تأكيد الطلب رقم {number} – {store}',
    'email.order.heading': 'شكرًا على طلبك',
    'email.order.intro': 'استلم {store} طلبك رقم {number}:',
    'email.order.line': '{title} — الكمية {quantity}: {amount}',
    'email.order.cashOnDelivery': 'الدفع عند الاستلام: يرجى تجهيز المبلغ الإجمالي.',
    'email.order.bankTransfer': 'الدفع بتحويل بنكي: {instructions}',
    'email.order.shipping': 'التوصيل إلى: {address}',
    'email.order.pickup': 'الاستلام من المتجر: سيتصل بك المتجر عندما يكون طلبك جاهزًا.',
    'email.newOrder.subject': 'طلب جديد رقم {number} ({total})',
    'email.newOrder.heading': 'طلب جديد',
    'email.newOrder.intro': 'قدّم {customer} الطلب رقم {number} بقيمة {total} في {store}.',
    'email.newOrder.action': 'عرض الطلب',
    'admin.language': 'اللغة',
    'admin.language.ar': 'العربية',
    'admin.language.aeb': 'تونسي',
    'admin.language.fr': 'Français',
    'admin.language.en': 'English',
    'admin.nav.home': 'الرئيسية',
    'admin.nav.account': 'حسابي',
    'admin.nav.security': 'الأمان',
    'admin.nav.signOut': 'تسجيل الخروج',
    'admin.nav.label': 'التنقل الرئيسي',
    'admin.nav.skip': 'انتقل إلى المحتوى',
    'admin.nav.viewStore': 'عرض المتجر',
    'admin.nav.store': 'تنقل المتجر',
    'admin.nav.menu': 'فتح القائمة',
    'admin.nav.closeMenu': 'إغلاق القائمة',
    'admin.nav.storeHome': 'نظرة عامة',
    'admin.nav.group.sales': 'المبيعات',
    'admin.nav.group.catalog': 'الكتالوج',
    'admin.nav.group.online': 'المتجر الإلكتروني',
    'admin.nav.group.fulfilment': 'التوصيل والتحصيل',
    'admin.nav.group.settings': 'الإعدادات',
    'admin.auth.tagline': 'أدر متجرك الإلكتروني، من الطلب إلى التحصيل.',
    'admin.auth.point.orders': 'الطلبات والتوصيل والدفع عند الاستلام في مكان واحد',
    'admin.auth.point.languages': 'متجر بالعربية والفرنسية والتونسية والإنجليزية',
    'admin.auth.point.secure': 'تسجيل الدخول برمز البريد الإلكتروني، مع تحقق بخطوتين اختياري',
    'admin.loading': 'جارٍ التحميل…',
    'admin.save': 'حفظ',
    'admin.saved': 'تم حفظ التغييرات.',
    'admin.copy': 'نسخ',
    'admin.copied': 'تم النسخ',
    'admin.download': 'تنزيل',
    'admin.loadMore': 'عرض المزيد',
    'storefront.reviews.title': 'آراء العملاء',
    'storefront.reviews.storeTitle': 'آراء حول المتجر',
    'storefront.reviews.count': '{count, plural, zero {لا آراء} one {رأي واحد} two {رأيان} few {# آراء} many {# رأيًا} other {# رأي}}',
    'storefront.reviews.average': '{average} من 5',
    'storefront.reviews.stars': '{rating} نجوم من 5',
    'storefront.reviews.bar': '{stars} نجوم: {count}',
    'storefront.reviews.empty': 'لا توجد آراء بعد.',
    'storefront.reviews.verified': 'شراء موثّق',
    'storefront.reviews.anonymous': 'عميل موثّق',
    'storefront.reviews.reply': 'ردّ المتجر',
    'storefront.reviews.pages': 'صفحات الآراء',
    'storefront.review.title': 'شاركنا رأيك',
    'storefront.review.intro': 'يُنشر رأيك بعد موافقة المتجر.',
    'storefront.review.store': 'المتجر (الخدمة، التوصيل…)',
    'storefront.review.rating': 'تقييمك',
    'storefront.review.star': '{count, plural, zero {لا نجوم} one {نجمة واحدة} two {نجمتان} few {# نجوم} many {# نجمة} other {# نجمة}}',
    'storefront.review.comment': 'تعليقك (اختياري)',
    'storefront.review.name': 'اسمك الأول (يظهر مع الرأي)',
    'storefront.review.submit': 'إرسال رأيي',
    'storefront.review.sent': 'شكرًا! سيُنشر رأيك بعد الموافقة عليه.',
    'storefront.review.done': 'تم إرسال الرأي',
    'storefront.review.error.already-reviewed': 'لقد شاركت رأيك مسبقًا.',
    'storefront.review.error.review-not-open': 'يمكنك مشاركة رأيك بعد تسليم الطلب.',
    'storefront.review.error.generic': 'تعذّر إرسال رأيك. تحقّق من الحقول وأعد المحاولة.',
    'storefront.comment.link': 'اترك تعليقًا',
    'storefront.comment.title': 'تعليق للمتجر',
    'storefront.comment.intro': 'لديك فكرة أو ملاحظة؟ تُرسل رسالتك إلى المتجر ولا تُنشر.',
    'storefront.comment.message': 'رسالتك',
    'storefront.comment.send': 'إرسال',
    'storefront.comment.sent': 'شكرًا، أُرسلت رسالتك إلى المتجر.',
    'storefront.comment.error': 'تعذّر إرسال الرسالة. أعد المحاولة لاحقًا.',
    'admin.reviews.title': 'آراء العملاء',
    'admin.reviews.empty': 'لا توجد آراء بعد.',
    'admin.reviews.search': 'بحث (نص أو اسم)',
    'admin.reviews.subject': 'حول',
    'admin.reviews.subject.product': 'منتج',
    'admin.reviews.subject.store': 'المتجر',
    'admin.reviews.rating': 'التقييم',
    'admin.reviews.stars': '{rating} من 5',
    'admin.reviews.status': 'الحالة',
    'admin.reviews.status.pending': 'بانتظار المراجعة',
    'admin.reviews.status.approved': 'منشور',
    'admin.reviews.status.hidden': 'مخفي',
    'admin.reviews.filter.allStatuses': 'كل الحالات',
    'admin.reviews.filter.allSubjects': 'المنتجات والمتجر',
    'admin.reviews.filter.allRatings': 'كل التقييمات',
    'admin.reviews.column.date': 'التاريخ',
    'admin.reviews.column.review': 'الرأي',
    'admin.reviews.column.author': 'العميل',
    'admin.reviews.order': 'الطلب رقم {number}',
    'admin.reviews.open': 'فتح الرأي بتاريخ {date}',
    'admin.reviews.anonymous': 'عميل (بيانات ممحوّة)',
    'admin.reviews.noComment': 'بدون تعليق',
    'admin.reviews.approve': 'نشر',
    'admin.reviews.hide': 'إخفاء',
    'admin.reviews.reply': 'ردّ علني',
    'admin.reviews.replyLabel': 'ردّك',
    'admin.reviews.replyHint': 'يظهر تحت الرأي في المتجر الإلكتروني.',
    'admin.reviews.saveReply': 'حفظ الردّ',
    'admin.reviews.removeReply': 'حذف الردّ',
    'admin.reviews.saved': 'تم تحديث الرأي.',
    'admin.reviews.error.version-conflict': 'تم تعديل الرأي في الأثناء. أعد تحميل الصفحة.',
    'admin.reviews.pending': '{count, plural, zero {لا آراء بانتظار المراجعة} one {رأي واحد بانتظار المراجعة} two {رأيان بانتظار المراجعة} few {# آراء بانتظار المراجعة} many {# رأيًا بانتظار المراجعة} other {# رأي بانتظار المراجعة}}',
    'admin.reviews.summary.store': 'المتجر',
    'admin.reviews.summary.products': 'المنتجات',
    'admin.reviews.summary.average': '{average}/5 · {count, plural, zero {لا آراء منشورة} one {رأي منشور واحد} two {رأيان منشوران} few {# آراء منشورة} many {# رأيًا منشورًا} other {# رأي منشور}}',
    'admin.reviews.summary.none': 'لا توجد آراء منشورة بعد',
    'admin.reviews.language': 'اللغة',
    'admin.comments.title': 'التعليقات',
    'admin.comments.intro': 'رسائل خاصة تركها زوار المتجر الإلكتروني.',
    'admin.comments.empty': 'لا توجد تعليقات بعد.',
    'admin.comments.search': 'البحث في الرسائل',
    'admin.comments.status': 'الحالة',
    'admin.comments.status.new': 'جديد',
    'admin.comments.status.handled': 'تمت معالجته',
    'admin.comments.filter.allStatuses': 'الكل',
    'admin.comments.column.message': 'الرسالة',
    'admin.comments.markHandled': 'تعليم كمُعالَج',
    'admin.comments.reopen': 'إعادة فتح',
    'admin.feedback.button': 'رأيك',
    'admin.feedback.title': 'رأيك في beinstore',
    'admin.feedback.intro': 'لديك اقتراح أو مشكلة؟ فريق beinstore يقرأ كل رسالة.',
    'admin.feedback.rating': 'تقييمك',
    'admin.feedback.category': 'الموضوع',
    'admin.feedback.category.suggestion': 'اقتراح',
    'admin.feedback.category.problem': 'مشكلة',
    'admin.feedback.category.other': 'أخرى',
    'admin.feedback.message': 'رسالتك',
    'admin.feedback.send': 'إرسال',
    'admin.feedback.sent': 'شكرًا على ملاحظاتك!',
    'admin.feedback.close': 'إغلاق',
    'admin.feedback.star': '{count, plural, zero {لا نجوم} one {نجمة واحدة} two {نجمتان} few {# نجوم} many {# نجمة} other {# نجمة}}',
    'admin.operator.feedback.title': 'آراء التجار',
    'admin.operator.feedback.average': 'متوسط التقييم: {average}/5 ({count, plural, zero {لا آراء} one {رأي واحد} two {رأيان} few {# آراء} many {# رأيًا} other {# رأي}})',
    'admin.operator.feedback.empty': 'لا توجد آراء بعد.',
    'admin.operator.feedback.author': 'التاجر',
    'admin.operator.feedback.store': 'المتجر',
    'admin.operator.feedback.page': 'الصفحة',
    'admin.operator.feedback.allCategories': 'كل المواضيع',
    'admin.operator.watch.title': 'العروض',
    'admin.operator.watch.intro': 'راقب كلمات في كتالوج كل متجر. أخفِ عرضاً أو أوقف المتجر إذا كان غير مسموح.',
    'admin.operator.watch.terms': 'الكلمات المراقبة',
    'admin.operator.watch.termsHint': 'كلمة في كل سطر، 4 أحرف على الأقل. تُبحث في العنوان والوصف والعنوان الإلكتروني والوسوم.',
    'admin.operator.watch.termsSave': 'حفظ القائمة',
    'admin.operator.watch.termsSaved': 'تم حفظ قائمة المراقبة.',
    'admin.operator.watch.suggest': 'إضافة كلمات مقترحة',
    'admin.operator.watch.flags': 'عروض مطابقة',
    'admin.operator.watch.recent': 'أحدث العروض',
    'admin.operator.watch.empty': 'لا يوجد تطابق مع قائمة المراقبة.',
    'admin.operator.watch.noTerms': 'احفظ كلمات مراقبة لرؤية العروض المطابقة.',
    'admin.operator.watch.matched': 'مطابقة',
    'admin.operator.watch.hide': 'إخفاء العرض',
    'admin.operator.watch.confirmHide': 'إخفاء هذا العرض؟',
    'admin.operator.watch.hidden': 'تم إخفاء العرض.',
    'admin.operator.watch.suspend': 'إيقاف المتجر',
    'admin.operator.watch.confirmSuspend': 'إيقاف هذا المتجر عن العمل؟',
    'admin.operator.watch.suspended': 'تم إيقاف المتجر.',
    'admin.operator.watch.resume': 'إعادة فتح المتجر',
    'admin.operator.watch.resumed': 'أُعيد فتح المتجر.',
    'admin.operator.watch.reason': 'السبب',
    'admin.operator.watch.open': 'فتح العرض',
    'admin.operator.watch.store': 'المتجر',
    'admin.operator.watch.product': 'العرض',
    'admin.operator.watch.search': 'البحث في العروض',
    'admin.operator.watch.actions': 'إجراءات',
    'admin.operator.merchants': 'التجار',
    'admin.operator.merchants.intro': 'كل حساب مالك والمتاجر التي يديرها. ابحث أو صفِّ أو صدّر أو استورد الهوية فقط — لا ينشئ الملف متجرًا.',
    'admin.operator.merchants.search': 'البحث بالبريد أو الاسم أو المتجر',
    'admin.operator.merchants.empty': 'لا يوجد تجار.',
    'admin.operator.merchants.stores': 'المتاجر',
    'admin.operator.merchants.stores.any': 'أي عدد',
    'admin.operator.merchants.stores.one': 'متجر واحد',
    'admin.operator.merchants.stores.several': 'عدة متاجر',
    'admin.operator.merchants.presence': 'حالة المتجر',
    'admin.operator.merchants.presence.any': 'أي حالة',
    'admin.operator.merchants.presence.unpublished': 'لديه متجر غير منشور',
    'admin.operator.merchants.presence.suspended': 'لديه متجر موقوف',
    'admin.operator.merchants.presence.live': 'لديه متجر نشط',
    'admin.operator.merchants.storeCount': 'المتاجر',
    'admin.operator.merchants.created': 'تاريخ الإنشاء',
    'admin.operator.merchants.card': 'التاجر',
    'admin.operator.merchants.otherStores': 'متاجر أخرى:',
    'admin.operator.merchants.noName': 'بدون اسم ظاهر',
    'admin.operator.merchants.csv': 'الاستيراد والتصدير',
    'admin.operator.merchants.export': 'تصدير (CSV)',
    'admin.operator.merchants.import': 'استيراد ملف CSV',
    'admin.operator.merchants.importHint': 'الأعمدة: email (مطلوب)، display_name، preferred_locale. يُفحص الملف أولًا ولا يُكتب شيء قبل التأكيد. لا ينشئ متاجر ولا يرسل بريدًا.',
    'admin.operator.merchants.importSummary': '{created} للإنشاء و{updated} للتحديث. لن يُنشأ أي متجر.',
    'admin.operator.merchants.importDone': 'اكتمل الاستيراد: {created} أُنشئ و{updated} حُدّث.',
    'admin.operator.merchants.importError.duplicate-email': 'هذا البريد يظهر مرتين في الملف.',
    'admin.operator.merchants.importError.operator-account': 'هذا العنوان لمشغّل المنصة. لا يمكن أن يملك متجرًا.',
    'admin.grid.pagination': 'ترقيم الصفحات',
    'admin.grid.range': '{from}–{to} من {total}',
    'admin.grid.pageSize': 'عدد الأسطر في الصفحة',
    'admin.grid.previous': 'الصفحة السابقة',
    'admin.grid.next': 'الصفحة التالية',
    'admin.grid.page': 'الصفحة {page}',
    'admin.grid.reset': 'إعادة الضبط',
    'admin.grid.noResults': 'لا توجد نتائج لهذه المعايير.',
    'admin.grid.from': 'من',
    'admin.grid.to': 'إلى',
    'admin.grid.filters': 'عوامل التصفية',
    'admin.order.paymentMethod': 'طريقة الدفع',
    'admin.order.deliveryMethod': 'طريقة التوصيل',
    'admin.order.filter.allPaymentMethods': 'كل طرق الدفع',
    'admin.order.filter.allDeliveryMethods': 'كل طرق التوصيل',
    'admin.inventory.filter.untracked': 'مخزون غير متابَع',
    'admin.discount.search': 'البحث عن رمز',
    'admin.discount.state': 'الوضعية',
    'admin.discount.state.active': 'صالح للاستعمال',
    'admin.discount.state.scheduled': 'مبرمج',
    'admin.discount.state.expired': 'منتهي الصلاحية',
    'admin.discount.state.exhausted': 'مستنفد',
    'admin.discount.state.disabled': 'معطّل',
    'admin.discount.filter.allStates': 'كل الوضعيات',
    'admin.audit.filter.allActors': 'كل المنفّذين',
    'admin.audit.filter.action': 'إجراء يحتوي على',
    'admin.error.invalid-code': 'الرمز غير صحيح. تحقق منه وحاول مرة أخرى.',
    'admin.error.code-expired': 'لم يعد هذا الرمز صالحًا. اطلب رمزًا جديدًا.',
    'admin.error.too-many-requests': 'محاولات كثيرة جدًا. حاول مرة أخرى بعد {seconds, plural, zero {# ثانية} one {ثانية واحدة} two {ثانيتين} few {# ثوانٍ} many {# ثانية} other {# ثانية}}.',
    'admin.error.email-unavailable': 'تعذّر إرسال البريد الإلكتروني. حاول مرة أخرى بعد قليل.',
    'admin.error.unauthenticated': 'انتهت صلاحية جلستك. يُرجى تسجيل الدخول مجددًا.',
    'admin.error.mfa-required': 'أكّد هويتك أولًا بعامل التحقق الثاني.',
    'admin.error.forbidden': 'لا يسمح دورك بهذا الإجراء.',
    'admin.error.network': 'مشكلة في الاتصال. تحقق من شبكتك وحاول مرة أخرى.',
    'admin.error.generic': 'حدث خطأ ما. حاول مرة أخرى.',
    'admin.signIn.title': 'تسجيل الدخول إلى {brand}',
    'admin.signIn.intro': 'نرسل إليك رمزًا من 6 أرقام عبر البريد الإلكتروني. لا حاجة إلى كلمة مرور.',
    'admin.signIn.email': 'البريد الإلكتروني',
    'admin.signIn.sendCode': 'أرسل لي رمزًا',
    'admin.signIn.codeTitle': 'تحقق من بريدك الإلكتروني',
    'admin.signIn.codeIntro': 'أدخل الرمز المرسل إلى {email}.',
    'admin.signIn.code': 'الرمز المكوّن من 6 أرقام',
    'admin.signIn.continue': 'متابعة',
    'admin.signIn.changeEmail': 'استخدام بريد إلكتروني آخر',
    'admin.signIn.resend': 'إرسال رمز جديد',
    'admin.mfa.verifyTitle': 'التحقق بخطوتين',
    'admin.mfa.verifyIntro': 'أدخل الرمز الظاهر في تطبيق المصادقة.',
    'admin.mfa.code': 'رمز التطبيق',
    'admin.mfa.verify': 'تحقق',
    'admin.mfa.useRecovery': 'استخدام رمز استرداد',
    'admin.mfa.useApp': 'استخدام تطبيق المصادقة',
    'admin.mfa.recoveryCode': 'رمز الاسترداد',
    'admin.mfa.setupTitle': 'احمِ حسابك',
    'admin.mfa.setupIntro': 'لحماية متجرك، يطلب كل تسجيل دخول رمزًا من هاتفك. امسح رمز QR هذا باستخدام تطبيق مصادقة.',
    'admin.mfa.qrAlt': 'رمز QR للمسح باستخدام تطبيق المصادقة',
    'admin.mfa.manualKey': 'تعذّر المسح؟ أدخل هذا المفتاح: {secret}',
    'admin.mfa.activate': 'تفعيل',
    'admin.mfa.recoveryTitle': 'احفظ رموز الاسترداد',
    'admin.mfa.recoveryIntro': 'يعمل كل رمز مرة واحدة إذا فقدت هاتفك. احفظها في مكان آمن: لن تُعرض مرة أخرى.',
    'admin.mfa.recoverySaved': 'لقد حفظتها',
    'admin.mfa.recoveryFileName': 'beinstore-recovery-codes.txt',
    'admin.home.title': 'مرحبًا {name}',
    'admin.home.titleAnonymous': 'مرحبًا',
    'admin.home.stores': 'متاجرك',
    'admin.home.noStores': 'ليس لديك وصول إلى أي متجر بعد.',
    'admin.home.auditLog': 'سجل التدقيق',
    'admin.role.owner': 'المالك',
    'admin.role.admin': 'مدير',
    'admin.role.staff': 'فريق العمل',
    'admin.role.support': 'الدعم',
    'admin.storeStatus.active': 'نشط',
    'admin.storeStatus.suspended': 'موقوف',
    'admin.storeStatus.provisioning': 'غير منشور',
    'admin.storeStatus.closed': 'مغلق',
    'admin.account.title': 'حسابي',
    'admin.account.email': 'البريد الإلكتروني',
    'admin.account.displayName': 'الاسم المعروض',
    'admin.account.preferredLocale': 'اللغة المفضلة (الرسائل والواجهة)',
    'admin.security.title': 'الأمان',
    'admin.security.sessions': 'الجلسات النشطة',
    'admin.security.thisDevice': 'هذا الجهاز',
    'admin.security.unknownDevice': 'جهاز غير معروف',
    'admin.security.lastActive': 'آخر نشاط: {date}',
    'admin.security.revoke': 'تسجيل الخروج',
    'admin.security.revokeOthers': 'تسجيل الخروج من كل الجلسات الأخرى',
    'admin.security.revokedOthers': '{count, plural, zero {لا توجد جلسات أخرى.} one {تم إنهاء جلسة واحدة.} two {تم إنهاء جلستين.} few {تم إنهاء # جلسات.} many {تم إنهاء # جلسة.} other {تم إنهاء # جلسة.}}',
    'admin.security.recoveryCodes': 'رموز الاسترداد',
    'admin.security.recoveryRemaining': '{count, plural, zero {لم يتبقَّ أي رمز.} one {يتبقى رمز واحد.} two {يتبقى رمزان.} few {يتبقى # رموز.} many {يتبقى # رمزًا.} other {يتبقى # رمز.}}',
    'admin.security.regenerate': 'إنشاء رموز جديدة',
    'admin.security.activity': 'النشاط الأخير',
    'admin.security.event.sign_in.code_verified': 'تم قبول رمز الدخول',
    'admin.security.event.sign_in.completed': 'تم تسجيل الدخول',
    'admin.security.event.sign_in.mfa_failed': 'فشل التحقق بخطوتين',
    'admin.security.event.account.created': 'تم إنشاء الحساب',
    'admin.security.event.mfa.totp_enrolled': 'تم تفعيل تطبيق المصادقة',
    'admin.security.event.mfa.recovery_codes_generated': 'تم إنشاء رموز استرداد جديدة',
    'admin.security.event.mfa.recovery_code_used': 'تم استخدام رمز استرداد',
    'admin.security.event.session.revoked': 'تم إنهاء جلسة',
    'admin.security.event.session.logged_out': 'تم تسجيل الخروج',
    'admin.security.mfa.title': 'التحقق بخطوتين',
    'admin.security.mfa.on': 'مفعّل: يطلب كل تسجيل دخول أيضًا رمزًا من تطبيق المصادقة.',
    'admin.security.mfa.off': 'غير مفعّل: تسجّل الدخول بالرمز المرسل إلى بريدك. فعّله ليُطلب أيضًا رمز من هاتفك.',
    'admin.security.mfa.enable': 'تفعيل',
    'admin.security.mfa.disable': 'إيقاف',
    'admin.security.mfa.codeHint': 'غير مطلوب خلال 15 دقيقة من تسجيل دخول بالتحقق بخطوتين.',
    'admin.security.mfa.disabled': 'تم إيقاف التحقق بخطوتين.',
    'admin.security.event.mfa.disabled': 'تم إيقاف التحقق بخطوتين',
    'admin.audit.title': 'سجل التدقيق',
    'admin.audit.date': 'التاريخ',
    'admin.audit.actor': 'المنفّذ',
    'admin.audit.action': 'الإجراء',
    'admin.audit.target': 'العنصر',
    'admin.audit.ip': 'عنوان IP',
    'admin.audit.empty': 'لا توجد أحداث بعد.',
    'admin.audit.actor.system': 'النظام',
    'admin.audit.actor.user': 'مستخدم',
    'admin.audit.actor.api_client': 'تطبيق',
    // --- module 4: stores, team, invitations ---
    'email.invitation.subject': 'دعوة للانضمام إلى {store} على {brand}',
    'email.invitation.heading': 'أنت مدعو للانضمام إلى {store}',
    'email.invitation.intro': 'يدعوك {inviter} للانضمام إلى فريق {store} على {brand} بدور «{role}».',
    'email.invitation.action': 'عرض الدعوة',
    'email.invitation.expiry': 'تنتهي صلاحية هذه الدعوة بعد {days, plural, zero {# يوم} one {يوم واحد} two {يومين} few {# أيام} many {# يومًا} other {# يوم}}.',
    'email.invitation.ignore': 'إذا كنت لا تعرف هذا المتجر فتجاهل هذه الرسالة.',
    'admin.error.conflict': 'يتعارض هذا الإجراء مع الحالة الحالية (ربما تم تنفيذه بالفعل).',
    'admin.home.createStore': 'إنشاء متجر',
    'admin.home.openStore': 'فتح',
    'admin.store.new.title': 'أنشئ متجرك',
    'admin.store.new.intro': 'اختر اسمًا وعنوانًا. ستضيف منتجاتك بعد ذلك.',
    'admin.store.nameIn': 'اسم المتجر ({language})',
    'admin.store.slug': 'عنوان المتجر',
    'admin.store.slugHint': 'أحرف لاتينية صغيرة وأرقام وشرطات. لا يمكن تغييره لاحقًا.',
    'admin.store.slugAvailable': '{host} متاح.',
    'admin.store.slug.invalid': 'استخدم من 3 إلى 40 حرفًا لاتينيًا صغيرًا أو رقمًا أو شرطة مفردة.',
    'admin.store.slug.reserved': 'هذا العنوان محجوز.',
    'admin.store.slug.taken': 'هذا العنوان مستخدم بالفعل.',
    'admin.store.defaultLocale': 'اللغة الرئيسية للمتجر',
    'admin.store.enabledLocales': 'لغات المتجر',
    'admin.store.create': 'إنشاء المتجر',
    'admin.store.settings': 'الإعدادات',
    'admin.store.team': 'الفريق',
    'admin.store.addresses': 'العناوين',
    'admin.store.error.defaultLocale': 'يجب أن تكون اللغة الرئيسية من لغات المتجر وأن يكون لها اسم.',
    'admin.team.members': 'الأعضاء',
    'admin.team.you': 'أنت',
    'admin.team.role': 'الدور',
    'admin.team.roleFor': 'دور {name}',
    'admin.team.remove': 'إزالة',
    'admin.team.removeFor': 'إزالة {name}',
    'admin.team.invitations': 'الدعوات المعلّقة',
    'admin.team.noInvitations': 'لا توجد دعوات معلّقة.',
    'admin.team.invite': 'دعوة شخص',
    'admin.team.inviteLocale': 'لغة الدعوة',
    'admin.team.send': 'إرسال الدعوة',
    'admin.team.sent': 'تم إرسال الدعوة.',
    'admin.team.expires': 'تنتهي في {date}',
    'admin.team.cancelInvitation': 'إلغاء',
    'admin.invitation.title': 'الانضمام إلى {store}',
    'admin.invitation.intro': 'أنت مدعو للانضمام إلى {store} بدور «{role}».',
    'admin.invitation.accept': 'قبول الدعوة',
    'admin.invitation.mismatch': 'أُرسلت هذه الدعوة إلى {email}. سجّل الدخول بهذا العنوان لقبولها.',
    'admin.invitation.invalid': 'لم تعد هذه الدعوة صالحة. اطلب دعوة جديدة من مالك المتجر.',
    'admin.media.title': 'مكتبة الصور',
    'admin.media.upload': 'إضافة صور',
    'admin.media.uploadHint': 'JPEG أو PNG أو WebP أو AVIF. تُحذف المعلومات المخفية في الصور (الموقع الجغرافي، نوع الجهاز).',
    'admin.media.uploading': 'جارٍ الإرسال: {done} من {total}…',
    'admin.media.uploaded': '{count, plural, zero {لم تُضف أي صورة.} one {أُضيفت صورة واحدة.} two {أُضيفت صورتان.} few {أُضيفت # صور.} many {أُضيفت # صورة.} other {أُضيفت # صورة.}}',
    'admin.media.empty': 'لا توجد صور بعد.',
    'admin.media.dimensions': '{width} × {height} بكسل',
    'admin.media.alt': 'وصف الصورة ({language})',
    'admin.media.altHint': 'يُقرأ للأشخاص ضعاف البصر وتستعمله محركات البحث.',
    'admin.media.edit': 'تعديل',
    'admin.media.editFor': 'تعديل وصف {name}',
    'admin.media.delete': 'حذف',
    'admin.media.deleteFor': 'حذف {name}',
    'admin.media.confirmDelete': 'تأكيد الحذف',
    'admin.media.cancel': 'إلغاء',
    'admin.media.deleted': 'حُذفت الصورة.',
    'admin.media.error.payload-too-large': '{name}: حجم الملف كبير جدًا.',
    'admin.media.error.unsupported-media-type': '{name}: صيغة غير مدعومة. استعمل JPEG أو PNG أو WebP أو AVIF.',
    'admin.media.error.invalid-image': '{name}: تعذّرت قراءة الصورة أو أبعادها كبيرة جدًا.',
    'admin.media.error.service-unavailable': 'مكتبة الصور غير متاحة حاليًا. حاول لاحقًا.',
    'admin.media.error.file': 'تعذّر إرسال {name}: {message}',
    'admin.catalog.products': 'المنتجات',
    'admin.catalog.collections': 'المجموعات',
    'admin.catalog.export': 'تصدير (CSV)',
    'admin.catalog.import': 'استيراد ملف CSV',
    'admin.catalog.importHint': 'سطر لكل نوع. يُفحص الملف أولًا: لا يتغيّر شيء قبل تأكيدك.',
    'admin.catalog.importChecking': 'جارٍ فحص الملف…',
    'admin.catalog.importSummary': '{products, plural, zero {لا منتجات} one {منتج واحد} two {منتجان} few {# منتجات} many {# منتجًا} other {# منتج}}: {created} للإنشاء، {updated} للتحديث.',
    'admin.catalog.importApply': 'استيراد',
    'admin.catalog.importDone': 'اكتمل الاستيراد: أُنشئ {created} وحُدّث {updated}.',
    'admin.catalog.importErrors': 'في الملف أخطاء. صحّحها ثم أعد المحاولة.',
    'admin.catalog.importErrorLine': 'السطر {line}: {message}',
    'admin.catalog.importErrorCell': 'السطر {line}، العمود {column}: {message}',
    'admin.catalog.importError.invalid-csv': 'الملف ليس بصيغة CSV صحيحة.',
    'admin.catalog.importError.no-rows': 'لا يحتوي الملف على أي منتج.',
    'admin.catalog.importError.unknown-column': 'عمود غير معروف.',
    'admin.catalog.importError.missing-column': 'عمود إلزامي مفقود.',
    'admin.catalog.importError.too-many-rows': 'عدد الأسطر كبير: 10000 سطر على الأكثر في الملف.',
    'admin.catalog.importError.too-many-products': 'عدد المنتجات كبير: 2000 منتج على الأكثر في الملف.',
    'admin.catalog.importError.required': 'قيمة إلزامية.',
    'admin.catalog.importError.differs': 'تختلف عن السطر الأول لهذا المنتج.',
    'admin.catalog.importError.option-numbering': 'تُرقّم الخيارات بدءًا من 1 دون فجوات.',
    'admin.catalog.importError.invalid-amount': 'مبلغ بالدينار بثلاثة أرقام عشرية على الأكثر، مثل 25.500.',
    'admin.catalog.importError.whole-grams': 'الوزن بالغرام دون كسور.',
    'admin.catalog.importError.sku-used': 'هذا الرمز SKU لمنتج آخر.',
    'admin.catalog.importError.invalid': 'قيمة غير صالحة.',
    'admin.product.new': 'منتج جديد',
    'admin.product.edit': 'تعديل المنتج',
    'admin.product.search': 'بحث (الاسم أو العنوان أو SKU)',
    'admin.product.statusFilter': 'الحالة',
    'admin.product.allStatuses': 'الكل',
    'admin.product.status.draft': 'مسودة',
    'admin.product.status.active': 'معروض للبيع',
    'admin.product.status.archived': 'مؤرشف',
    'admin.product.empty': 'لا توجد منتجات بعد.',
    'admin.product.noMatch': 'لا توجد منتجات مطابقة لبحثك.',
    'admin.product.column.product': 'المنتج',
    'admin.product.column.status': 'الحالة',
    'admin.product.column.variants': 'الأنواع',
    'admin.product.column.price': 'السعر',
    'admin.product.column.updated': 'آخر تعديل',
    'admin.product.priceRange': 'من {min} إلى {max}',
    'admin.product.titleIn': 'الاسم ({language})',
    'admin.product.descriptionIn': 'الوصف ({language})',
    'admin.product.handle': 'عنوان الصفحة',
    'admin.product.handleHint': 'حروف لاتينية صغيرة وأرقام وشرطات. اتركه فارغًا ليُستخرج من الاسم.',
    'admin.product.tags': 'الوسوم',
    'admin.product.tagsHint': 'مفصولة بفواصل.',
    'admin.product.details': 'المعلومات',
    'admin.product.options': 'الخيارات',
    'admin.product.optionsHint': 'مثل المقاس أو اللون. كل تركيبة من القيم تصبح نوعًا.',
    'admin.product.addOption': 'إضافة خيار',
    'admin.product.removeOption': 'حذف الخيار {number}',
    'admin.product.optionNameIn': 'اسم الخيار {number} ({language})',
    'admin.product.optionValues': 'قيم الخيار {number}',
    'admin.product.valueIn': 'القيمة {index} ({language})',
    'admin.product.addValue': 'إضافة قيمة',
    'admin.product.removeValue': 'حذف القيمة {index}',
    'admin.product.variants': 'الأسعار والأنواع',
    'admin.product.variant': 'النوع',
    'admin.product.price': 'السعر (د.ت)',
    'admin.product.priceFor': 'سعر {variant} (د.ت)',
    'admin.product.compareAt': 'السعر قبل التخفيض (د.ت)',
    'admin.product.compareAtFor': 'سعر {variant} قبل التخفيض (د.ت)',
    'admin.product.sku': 'رمز SKU',
    'admin.product.skuFor': 'رمز SKU لـ {variant}',
    'admin.product.barcode': 'الرمز الشريطي',
    'admin.product.weight': 'الوزن (غ)',
    'admin.product.tooManyVariants': '{max} نوعًا على الأكثر: قلّل عدد القيم.',
    'admin.product.images': 'الصور',
    'admin.product.noImages': 'لا توجد صور.',
    'admin.product.addImages': 'اختيار من مكتبة الصور',
    'admin.product.closePicker': 'إغلاق',
    'admin.product.selectImage': 'اختيار {name}',
    'admin.product.moveUp': 'تقديم {name}',
    'admin.product.moveDown': 'تأخير {name}',
    'admin.product.removeImage': 'إزالة {name}',
    'admin.product.save': 'حفظ المنتج',
    'admin.product.saved': 'حُفظ المنتج.',
    'admin.product.delete': 'حذف المنتج',
    'admin.product.confirmDelete': 'تأكيد حذف المنتج',
    'admin.product.deleted': 'حُذف المنتج.',
    'admin.product.invalidPrice': 'مبلغ بالدينار بثلاثة أرقام عشرية على الأكثر، مثل 25.500.',
    'admin.product.error.version-conflict': 'عُدّل هذا المنتج في الأثناء. أعد تحميل الصفحة ثم أعد تعديلاتك.',
    'admin.product.error.handle-taken': 'هذا العنوان مستعمل.',
    'admin.product.error.sku-taken': 'أحد رموز SKU مستعمل لمنتج آخر.',
    'admin.product.error.validation': 'بعض الحقول غير صالحة. راجع الاستمارة.',
    'admin.collection.new': 'مجموعة جديدة',
    'admin.collection.edit': 'تعديل المجموعة',
    'admin.collection.empty': 'لا توجد مجموعات بعد.',
    'admin.collection.productCount': '{count, plural, zero {لا منتجات} one {منتج واحد} two {منتجان} few {# منتجات} many {# منتجًا} other {# منتج}}',
    'admin.collection.products': 'منتجات المجموعة',
    'admin.collection.noProducts': 'لا توجد منتجات في هذه المجموعة.',
    'admin.collection.findProducts': 'البحث عن منتجات لإضافتها',
    'admin.collection.addProduct': 'إضافة {name}',
    'admin.collection.removeProduct': 'إزالة {name}',
    'admin.collection.status.draft': 'مسودة',
    'admin.collection.status.active': 'ظاهرة',
    'admin.collection.save': 'حفظ المجموعة',
    'admin.collection.saved': 'حُفظت المجموعة.',
    'admin.collection.delete': 'حذف المجموعة',
    'admin.collection.confirmDelete': 'تأكيد حذف المجموعة',
    'admin.collection.deleted': 'حُذفت المجموعة.',
    'admin.catalog.csv': 'الاستيراد والتصدير',
    'admin.inventory.title': 'المخزون',
    'admin.inventory.search': 'بحث (الاسم أو SKU)',
    'admin.inventory.filter': 'عرض',
    'admin.inventory.filter.all': 'كل الأصناف',
    'admin.inventory.filter.tracked': 'المخزون المتابَع',
    'admin.inventory.filter.out-of-stock': 'نفد من المخزون',
    'admin.inventory.empty': 'لا توجد أصناف.',
    'admin.inventory.column.item': 'الصنف',
    'admin.inventory.column.onHand': 'في المخزون',
    'admin.inventory.column.reserved': 'محجوز',
    'admin.inventory.column.available': 'متاح',
    'admin.inventory.column.state': 'الحالة',
    'admin.inventory.state.untracked': 'غير متابَع (بيع دون حد)',
    'admin.inventory.state.backorder': 'يُباع رغم نفاد المخزون',
    'admin.inventory.state.out': 'نفد من المخزون',
    'admin.inventory.state.in': 'متاح',
    'admin.inventory.manage': 'إدارة مخزون {name}',
    'admin.inventory.settings': 'متابعة المخزون',
    'admin.inventory.track': 'متابعة مخزون هذا الصنف',
    'admin.inventory.allowBackorder': 'مواصلة البيع عند نفاد المخزون',
    'admin.inventory.saveSettings': 'حفظ الإعدادات',
    'admin.inventory.settingsSaved': 'حُفظت الإعدادات.',
    'admin.inventory.adjust': 'تعديل المخزون',
    'admin.inventory.reason': 'السبب',
    'admin.inventory.reason.received': 'استلام',
    'admin.inventory.reason.returned': 'إرجاع من حريف',
    'admin.inventory.reason.damaged': 'تالف أو مفقود',
    'admin.inventory.reason.correction': 'تصحيح',
    'admin.inventory.reason.count': 'جرد',
    'admin.inventory.reason.reserved': 'حجز',
    'admin.inventory.reason.released': 'إلغاء حجز',
    'admin.inventory.reason.expired': 'انتهاء الحجز',
    'admin.inventory.reason.committed': 'بيع',
    'admin.inventory.reason.tracking': 'إعدادات المتابعة',
    'admin.inventory.quantity': 'الكمية',
    'admin.inventory.quantityHint': 'عدد الوحدات المضافة أو المسحوبة.',
    'admin.inventory.correctionHint': 'العدد السالب يسحب من المخزون.',
    'admin.inventory.note': 'ملاحظة (اختيارية)',
    'admin.inventory.apply': 'حفظ التعديل',
    'admin.inventory.count': 'جرد فعلي',
    'admin.inventory.counted': 'الكمية المعدودة',
    'admin.inventory.saveCount': 'حفظ الجرد',
    'admin.inventory.saved': 'حُدّث المخزون.',
    'admin.inventory.history': 'السجل',
    'admin.inventory.noHistory': 'لا توجد حركات بعد.',
    'admin.inventory.column.date': 'التاريخ',
    'admin.inventory.column.change': 'التغيير',
    'admin.inventory.column.after': 'المخزون بعده',
    'admin.inventory.column.note': 'ملاحظة',
    'admin.inventory.error.stock-conflict': 'لا يمكن أن ينزل المخزون تحت الصفر أو تحت الكميات المحجوزة.',
    'admin.inventory.error.quantity': 'أدخل عددًا صحيحًا.',
    'storefront.skipToContent': 'الانتقال إلى المحتوى',
    'storefront.menu': 'القائمة الرئيسية',
    'storefront.language': 'اللغة',
    'storefront.search': 'بحث',
    'storefront.searchLabel': 'البحث عن منتج',
    'storefront.searchTitle': 'البحث',
    'storefront.results': '{count, plural, zero {لا نتائج} one {نتيجة واحدة} two {نتيجتان} few {# نتائج} many {# نتيجة} other {# نتيجة}} لـ «{query}»',
    'storefront.noResults': 'لا توجد منتجات مطابقة لبحثك.',
    'storefront.searchUnavailable': 'البحث غير متاح حاليًا. أعد المحاولة بعد قليل.',
    'storefront.sort': 'الترتيب حسب',
    'storefront.sort.relevance': 'الأكثر صلة',
    'storefront.sort.price-asc': 'السعر من الأقل إلى الأعلى',
    'storefront.sort.price-desc': 'السعر من الأعلى إلى الأقل',
    'storefront.sort.newest': 'الأحدث',
    'storefront.apply': 'تطبيق',
    'storefront.previous': 'الصفحة السابقة',
    'storefront.next': 'الصفحة التالية',
    'storefront.available': 'متوفر',
    'storefront.soldOut': 'نفد',
    'storefront.from': 'ابتداءً من {price}',
    'storefront.oldPrice': 'السعر السابق: {price}',
    'storefront.viewAll': 'عرض الكل',
    'storefront.emptyCollection': 'لا توجد منتجات بعد.',
    'storefront.productImages': 'صور {title}',
    'storefront.noCombination': 'هذه التركيبة غير متوفرة.',
    'storefront.preview': 'معاينة: هذه النسخة من المتجر لم تُنشر بعد.',
    'storefront.notFound': 'الصفحة غير موجودة',
    'storefront.notFoundText': 'الصفحة التي تبحث عنها غير موجودة أو لم تعد متاحة.',
    'storefront.backHome': 'العودة إلى الصفحة الرئيسية',
    'storefront.storeNotFound': 'هذا المتجر غير موجود.',
    'storefront.storeUnavailable': 'هذا المتجر غير متاح مؤقتًا.',
    'storefront.error': 'حدث خطأ.',
    'storefront.retry': 'إعادة المحاولة',
    'storefront.poweredBy': 'متجر أُنشئ بواسطة {brand}',
    'admin.theme.title': 'مظهر المتجر',
    'admin.theme.colors': 'الألوان والهوية',
    'admin.theme.color.background': 'الخلفية',
    'admin.theme.color.text': 'النص',
    'admin.theme.color.accent': 'الأزرار والروابط',
    'admin.theme.color.accentText': 'نص الأزرار',
    'admin.theme.contrastLow': 'التباين غير كافٍ ({ratio}:1، الحد الأدنى 4.5:1): ستصعب قراءة النص.',
    'admin.theme.logo': 'الشعار',
    'admin.theme.noImage': 'دون صورة',
    'admin.theme.announcementIn': 'شريط الإعلان ({language})',
    'admin.theme.navigation': 'القائمة',
    'admin.theme.addNavItem': 'إضافة رابط إلى القائمة',
    'admin.theme.navLabelIn': 'عنوان الرابط {number} ({language})',
    'admin.theme.linkFor': 'وجهة الرابط {number}',
    'admin.theme.removeNav': 'حذف الرابط {number}',
    'admin.theme.link.none': 'لا شيء',
    'admin.theme.link.home': 'الرئيسية',
    'admin.theme.link.search': 'البحث',
    'admin.theme.link.collection': 'مجموعة: {name}',
    'admin.theme.link.product': 'منتج: {name}',
    'admin.theme.sections': 'الصفحة الرئيسية',
    'admin.theme.sectionType': 'نوع القسم',
    'admin.theme.addSection': 'إضافة القسم',
    'admin.theme.section.hero': 'لافتة',
    'admin.theme.section.featured-collection': 'مجموعة مميزة',
    'admin.theme.section.product-grid': 'أحدث المنتجات',
    'admin.theme.section.rich-text': 'نص',
    'admin.theme.section.image-with-text': 'صورة ونص',
    'admin.theme.sectionN': 'القسم {number}: {type}',
    'admin.theme.headingIn': 'العنوان ({language})',
    'admin.theme.textIn': 'النص ({language})',
    'admin.theme.buttonLabelIn': 'نص الزر ({language})',
    'admin.theme.buttonLink': 'وجهة الزر',
    'admin.theme.image': 'الصورة',
    'admin.theme.imagePosition': 'موضع الصورة',
    'admin.theme.imagePosition.start': 'قبل النص',
    'admin.theme.imagePosition.end': 'بعد النص',
    'admin.theme.collection': 'المجموعة',
    'admin.theme.limit': 'عدد المنتجات',
    'admin.theme.moveUp': 'تقديم القسم {number}',
    'admin.theme.moveDown': 'تأخير القسم {number}',
    'admin.theme.remove': 'حذف القسم {number}',
    'admin.theme.save': 'حفظ المسودة',
    'admin.theme.saved': 'حُفظت المسودة.',
    'admin.theme.preview': 'معاينة',
    'admin.theme.openPreview': 'فتح المعاينة',
    'admin.theme.previewHint': 'رابط المعاينة صالح لمدة ساعة.',
    'admin.theme.publish': 'نشر',
    'admin.theme.published': 'تم النشر: يرى حرفاؤك الآن هذه النسخة.',
    'admin.theme.unpublished': 'بعض التعديلات لم تُنشر بعد.',
    'admin.theme.upToDate': 'يعرض المتجر آخر نسخة منشورة.',
    'admin.theme.history': 'النسخ المنشورة',
    'admin.theme.noHistory': 'لم يُنشر شيء بعد.',
    'admin.theme.version': 'النسخة {number}',
    'admin.theme.current': 'منشورة',
    'admin.theme.restore': 'استرجاع النسخة {number}',
    'admin.theme.restored': 'استُرجعت النسخة في المسودة. انشرها لتظهر للحرفاء.',
    'admin.theme.error.version-conflict': 'عُدّل المظهر في الأثناء. أعد تحميل الصفحة.',
    'admin.theme.template': 'القالب',
    'admin.theme.template.souk': 'السوق',
    'admin.theme.template.atelier': 'الورشة',
    'admin.theme.template.ledger': 'الدفتر',
    'admin.theme.template.hint': 'تطبيق قالب يستبدل ألوان المسودة والصفحة الرئيسية. الشعار والقائمة والصفحات تبقى. يراها الحرفاء بعد النشر.',
    'admin.theme.template.apply': 'تطبيق {name}',
    'admin.theme.template.confirm': 'استبدال ألوان المسودة والصفحة الرئيسية بهذا القالب؟ الموقع المنشور لا يتغير إلا عند النشر.',
    'admin.theme.template.applied': 'طُبّق القالب على المسودة. انشره ليظهر للحرفاء.',
    'admin.theme.link.page': 'صفحة: {name}',
    'admin.theme.pages': 'الصفحات',
    'admin.theme.addPage': 'إضافة صفحة',
    'admin.theme.pageHandle': 'عنوان الصفحة {number}',
    'admin.theme.pageTitleIn': 'عنوان الصفحة {number} ({language})',
    'admin.theme.removePage': 'حذف الصفحة {number}',
    'admin.theme.pageSectionType': 'نوع قسم الصفحة {number}',
    'admin.theme.addPageSection': 'إضافة قسم إلى الصفحة {number}',
    'admin.theme.slots.product': 'صفحة المنتج',
    'admin.theme.slots.collection': 'صفحة المجموعة',
    'admin.theme.slots.cart': 'السلة',
    'admin.theme.slots.before': 'قبل المحتوى',
    'admin.theme.slots.after': 'بعد المحتوى',
    'admin.theme.slotSectionType': 'نوع القسم ({place})',
    'admin.theme.addSlotSection': 'إضافة قسم ({place})',
    'admin.theme.place.product.before': 'قبل المنتج',
    'admin.theme.place.product.after': 'بعد المنتج',
    'admin.theme.place.collection.before': 'قبل المجموعة',
    'admin.theme.place.collection.after': 'بعد المجموعة',
    'admin.theme.place.cart.before': 'قبل السلة',
    'admin.theme.place.cart.after': 'بعد السلة',
    'admin.theme.reservedHandle': 'هذا العنوان مستخدم في المتجر (السلة، الدفع، البحث…).',
    'admin.theme.duplicateHandle': 'لا يمكن لصفحتين أن تشتركا في العنوان نفسه.',
    // --- module 10: checkout settings, discount codes, orders ---
    'admin.checkout.title': 'الدفع والتوصيل',
    'admin.checkout.unavailable': 'لا يستقبل المتجر الطلبات بعد: فعّل طريقة دفع واحدة وطريقة توصيل واحدة على الأقل.',
    'admin.checkout.available': 'المتجر يستقبل الطلبات.',
    'admin.checkout.saved': 'تم حفظ الإعدادات.',
    'admin.checkout.error.validation': 'تحقق من الحقول المشار إليها.',
    'admin.checkout.error.version-conflict': 'تم تغيير الإعدادات في الأثناء. أعد تحميل الصفحة.',
    'admin.checkout.payments': 'طرق الدفع',
    'admin.checkout.cashOnDelivery': 'الدفع عند الاستلام',
    'admin.checkout.bankTransfer': 'تحويل بنكي (تؤكد أنت الاستلام)',
    'admin.checkout.bankInstructionsIn': 'تعليمات التحويل ({language})',
    'admin.checkout.bankInstructionsHint': 'رقم الحساب البنكي وصاحبه: يظهران للحريف وفي بريد التأكيد.',
    'admin.checkout.delivery': 'التوصيل',
    'admin.checkout.shippingEnabled': 'التوصيل إلى المنزل',
    'admin.checkout.zone': 'المنطقة {number}',
    'admin.checkout.zoneNameIn': 'اسم المنطقة ({language})',
    'admin.checkout.zonePrice': 'معلوم التوصيل (د.ت)',
    'admin.checkout.zoneFreeOver': 'توصيل مجاني ابتداءً من (د.ت، اختياري)',
    'admin.checkout.zoneGovernorates': 'الولايات المخدومة',
    'admin.checkout.addZone': 'إضافة منطقة',
    'admin.checkout.removeZone': 'حذف المنطقة {number}',
    'admin.checkout.pickupEnabled': 'الاستلام من المتجر',
    'admin.checkout.pickupAddressIn': 'عنوان الاستلام ({language})',
    'admin.checkout.taxes': 'الضرائب',
    'admin.checkout.taxesEnabled': 'احتساب الأداء على القيمة المضافة (مؤسسة خاضعة)',
    'admin.checkout.taxesHint': 'النسب من اختيارك: تحقق منها مع محاسبك. لا يطبق beinstore أي نسبة افتراضيًا.',
    'admin.checkout.pricesIncludeTax': 'أسعار المتجر',
    'admin.checkout.pricesIncludeTax.yes': 'تشمل الأداء',
    'admin.checkout.pricesIncludeTax.no': 'دون احتساب الأداء (يضاف عند الدفع)',
    'admin.checkout.fiscalId': 'المعرّف الجبائي',
    'admin.checkout.taxClass': 'النسبة {number}',
    'admin.checkout.taxClassKey': 'الرمز (تستعمله المنتجات وملف CSV)',
    'admin.checkout.taxClassNameIn': 'الاسم ({language})',
    'admin.checkout.taxClassRate': 'النسبة (%)',
    'admin.checkout.addTaxClass': 'إضافة نسبة',
    'admin.checkout.removeTaxClass': 'حذف النسبة {number}',
    'admin.checkout.defaultClass': 'نسبة المنتجات دون نسبة',
    'admin.checkout.shippingClass': 'النسبة المطبقة على التوصيل',
    'admin.checkout.noClass': 'لا شيء (دون أداء)',
    'admin.checkout.fee': 'معلوم قار لكل طلب',
    'admin.checkout.feeAmount': 'المبلغ (د.ت، فارغ = لا شيء)',
    'admin.checkout.feeLabelIn': 'التسمية ({language})',
    'admin.checkout.feeHint': 'مثلًا طابع جبائي إن كنت تطبقه.',
    'admin.checkout.invalidAmount': 'مبلغ غير صالح.',
    'admin.checkout.invalidRate': 'نسبة غير صالحة (من 0 إلى 100، رقمان عشريان على الأكثر).',
    'admin.checkout.invalidKey': 'حروف لاتينية صغيرة وأرقام وشرطات.',
    'admin.discount.title': 'رموز التخفيض',
    'admin.discount.new': 'رمز جديد',
    'admin.discount.empty': 'لا توجد رموز تخفيض بعد.',
    'admin.discount.column.code': 'الرمز',
    'admin.discount.column.value': 'التخفيض',
    'admin.discount.column.used': 'الاستعمالات',
    'admin.discount.column.status': 'الحالة',
    'admin.discount.column.validity': 'الصلاحية',
    'admin.discount.kind': 'نوع التخفيض',
    'admin.discount.kind.percentage': 'نسبة مئوية',
    'admin.discount.kind.fixed_amount': 'مبلغ ثابت',
    'admin.discount.kind.free_shipping': 'توصيل مجاني',
    'admin.discount.value.percentage': '{percent}٪ تخفيض',
    'admin.discount.code': 'الرمز',
    'admin.discount.codeHint': 'حروف وأرقام و - و _ (من 3 إلى 40). يمكن للحرفاء كتابته بحروف صغيرة.',
    'admin.discount.percent': 'النسبة المئوية (%)',
    'admin.discount.amount': 'المبلغ (د.ت)',
    'admin.discount.minSubtotal': 'الحد الأدنى لمبلغ السلة (د.ت، اختياري)',
    'admin.discount.startsOn': 'صالح ابتداءً من (اختياري)',
    'admin.discount.endsOn': 'صالح إلى غاية (مشمول، اختياري)',
    'admin.discount.datesHint': 'التواريخ بتوقيت تونس.',
    'admin.discount.usageLimit': 'العدد الجملي للاستعمالات (اختياري)',
    'admin.discount.perCustomerLimit': 'عدد الاستعمالات لكل حريف (اختياري)',
    'admin.discount.perCustomerHint': 'يُعرف الحريف برقم هاتفه.',
    'admin.discount.status': 'الحالة',
    'admin.discount.status.active': 'مفعّل',
    'admin.discount.status.disabled': 'معطّل',
    'admin.discount.always': 'دون حد زمني',
    'admin.discount.from': 'ابتداءً من {date}',
    'admin.discount.until': 'إلى غاية {date}',
    'admin.discount.between': 'من {start} إلى {end}',
    'admin.discount.edit': 'تعديل الرمز',
    'admin.discount.saved': 'تم حفظ الرمز.',
    'admin.discount.error.conflict': 'هذا الرمز موجود.',
    'admin.discount.error.version-conflict': 'تم تغيير الرمز في الأثناء. أعد تحميل الصفحة.',
    'admin.discount.error.validation': 'تحقق من الحقول المشار إليها.',
    'admin.discount.invalidPercent': 'بين 0.01 و100.',
    'admin.discount.invalidNumber': 'عدد صحيح موجب.',
    'admin.discount.invalidDates': 'يجب أن تكون النهاية بعد البداية.',
    'admin.order.title': 'الطلبات',
    'admin.order.search': 'بحث (الاسم أو الهاتف أو الرقم)',
    'admin.order.empty': 'لا توجد طلبات بعد.',
    'admin.order.column.number': 'الرقم',
    'admin.order.column.date': 'التاريخ',
    'admin.order.column.customer': 'الحريف',
    'admin.order.column.total': 'المجموع',
    'admin.order.column.payment': 'الدفع',
    'admin.order.column.delivery': 'التوصيل',
    'admin.order.number': 'الطلب رقم {number}',
    'admin.order.open': 'فتح الطلب رقم {number}',
    'admin.order.payment.cash_on_delivery': 'عند الاستلام',
    'admin.order.payment.bank_transfer': 'تحويل بنكي',
    'admin.order.paymentStatus': 'حالة الدفع',
    'admin.order.paymentStatus.pending': 'في الانتظار',
    'admin.order.paymentStatus.paid': 'مدفوع',
    'admin.order.delivery.shipping': 'التوصيل إلى المنزل',
    'admin.order.delivery.pickup': 'الاستلام من المتجر',
    'admin.order.placedAt': 'بتاريخ {date}',
    'admin.order.customer': 'الحريف',
    'admin.order.phone': 'الهاتف',
    'admin.order.email': 'البريد الإلكتروني',
    'admin.order.address': 'عنوان التوصيل',
    'admin.order.note': 'ملاحظة الحريف',
    'admin.order.items': 'السلع',
    'admin.order.column.item': 'السلعة',
    'admin.order.column.unitPrice': 'سعر الوحدة',
    'admin.order.column.quantity': 'الكمية',
    'admin.order.subtotal': 'المجموع الفرعي',
    'admin.order.discount': 'التخفيض ({code})',
    'admin.order.shipping': 'التوصيل',
    'admin.order.tax': 'الأداء على القيمة المضافة',
    'admin.order.taxIncluded': 'منها الأداء',
    'admin.order.taxLine': 'أداء {rate}٪ على {net}: {tax}',
    'admin.order.fee': 'معلوم ({label})',
    'admin.order.total': 'المجموع',
    'admin.order.instructions': 'التعليمات المرسلة إلى الحريف',
    'admin.order.fiscalNote': 'المبالغ مسجلة عند الطلب ولا تتغير بعد ذلك.',
    'admin.product.taxClass': 'نسبة الأداء',
    'admin.product.taxClass.default': 'النسبة الافتراضية للمتجر',
    'admin.product.taxClass.unknown': '{key} (غير موجودة في الإعدادات: تطبق النسبة الافتراضية)',
    // --- module 10: storefront cart and checkout ---
    'storefront.cart': 'السلة',
    'storefront.cartWithCount': 'السلة ({count, plural, =0 {فارغة} one {سلعة واحدة} two {سلعتان} few {# سلع} many {# سلعة} other {# سلعة}})',
    'storefront.cart.title': 'سلة مشترياتك',
    'storefront.cart.empty': 'سلتك فارغة.',
    'storefront.cart.continue': 'مواصلة التسوق',
    'storefront.cart.product': 'السلعة',
    'storefront.cart.price': 'السعر',
    'storefront.cart.quantity': 'الكمية',
    'storefront.cart.quantityOf': 'كمية {title}',
    'storefront.cart.lineTotal': 'المجموع',
    'storefront.cart.update': 'تحديث',
    'storefront.cart.remove': 'حذف',
    'storefront.cart.removeItem': 'حذف {title} من السلة',
    'storefront.cart.unavailable': 'لم تعد متوفرة: احذفها لإتمام الطلب.',
    'storefront.cart.subtotal': 'المجموع الفرعي',
    'storefront.cart.discount': 'التخفيض ({code})',
    'storefront.cart.shipping': 'التوصيل',
    'storefront.cart.shippingLater': 'تُحتسب في الخطوة الموالية',
    'storefront.cart.free': 'مجاني',
    'storefront.cart.tax': 'الأداء على القيمة المضافة',
    'storefront.cart.taxIncluded': 'منها الأداء',
    'storefront.cart.fee': 'معلوم',
    'storefront.cart.total': 'المجموع',
    'storefront.cart.checkout': 'إتمام الطلب',
    'storefront.cart.checkoutUnavailable': 'لا يستقبل هذا المتجر الطلبات عبر الإنترنت بعد.',
    'storefront.cart.add': 'أضف إلى السلة',
    'storefront.cart.error.sold-out': 'نفدت هذه السلعة.',
    'storefront.cart.error.full': 'سلتك ممتلئة.',
    'storefront.cart.error.unavailable': 'هذه السلعة لم تعد متوفرة.',
    'storefront.cart.error.too-many': 'محاولات كثيرة. أعد المحاولة بعد دقائق.',
    'storefront.cart.error.generic': 'حدث خطأ. أعد المحاولة.',
    'storefront.discount.label': 'رمز التخفيض',
    'storefront.discount.apply': 'تطبيق',
    'storefront.discount.remove': 'إزالة الرمز',
    'storefront.discount.applied': 'تم تطبيق رمز التخفيض.',
    'storefront.discount.refusal.unknown': 'هذا الرمز غير موجود.',
    'storefront.discount.refusal.inactive': 'هذا الرمز لم يعد مفعّلًا.',
    'storefront.discount.refusal.not-started': 'هذا الرمز غير صالح بعد.',
    'storefront.discount.refusal.expired': 'انتهت صلاحية هذا الرمز.',
    'storefront.discount.refusal.minimum': 'مبلغ السلة غير كافٍ لهذا الرمز.',
    'storefront.discount.refusal.exhausted': 'بلغ هذا الرمز حد الاستعمال.',
    'storefront.discount.refusal.customer-limit': 'سبق أن استعملت هذا الرمز.',
    'storefront.discount.refusal.too-many': 'محاولات كثيرة. أعد المحاولة لاحقًا.',
    'storefront.discount.refusal.error': 'تعذر التحقق من الرمز. أعد المحاولة.',
    'storefront.checkout.title': 'إتمام الطلب',
    'storefront.checkout.backToCart': 'العودة إلى السلة',
    'storefront.checkout.deliveryChoice': 'طريقة التوصيل',
    'storefront.checkout.pickup': 'الاستلام من المتجر',
    'storefront.checkout.pickupAt': 'الاستلام من المتجر: {address}',
    'storefront.checkout.shippingTo': 'التوصيل إلى المنزل',
    'storefront.checkout.governorate': 'الولاية',
    'storefront.checkout.choose': 'اختر…',
    'storefront.checkout.governoratePrice': '{name} — {price} للتوصيل',
    'storefront.checkout.governoratePriceFree': '{name} — {price}، مجاني ابتداءً من {amount}',
    'storefront.checkout.continue': 'متابعة',
    'storefront.checkout.change': 'تغيير التوصيل',
    'storefront.checkout.notServed': 'لا يوصل المتجر إلى هذه الولاية.',
    'storefront.checkout.contact': 'معلوماتك',
    'storefront.checkout.name': 'الاسم واللقب',
    'storefront.checkout.phone': 'الهاتف',
    'storefront.checkout.phoneHint': 'رقم تونسي من 8 أرقام، أو دولي مع +',
    'storefront.checkout.email': 'البريد الإلكتروني (اختياري، لتلقي التأكيد)',
    'storefront.checkout.address': 'عنوان التوصيل',
    'storefront.checkout.city': 'المدينة',
    'storefront.checkout.line1': 'العنوان (النهج، الرقم)',
    'storefront.checkout.line2': 'تكملة العنوان (اختياري)',
    'storefront.checkout.postalCode': 'الرمز البريدي (اختياري)',
    'storefront.checkout.payment': 'الدفع',
    'storefront.checkout.cashOnDelivery': 'الدفع عند الاستلام',
    'storefront.checkout.bankTransfer': 'تحويل بنكي',
    'storefront.checkout.note': 'ملاحظة للمتجر (اختياري)',
    'storefront.checkout.place': 'تأكيد الطلب ({total})',
    'storefront.checkout.summary': 'الملخص',
    'storefront.checkout.field.required': 'هذا الحقل إجباري.',
    'storefront.checkout.field.phone': 'رقم هاتف غير صالح.',
    'storefront.checkout.field.email': 'بريد إلكتروني غير صالح.',
    'storefront.checkout.field.postalCode': 'أربعة أرقام.',
    'storefront.checkout.field.invalid': 'قيمة غير صالحة.',
    'storefront.checkout.error.validation': 'تحقق من المعلومات المدخلة.',
    'storefront.checkout.error.cart-changed': 'بعض السلع لم تعد متوفرة. تحقق من سلتك.',
    'storefront.checkout.error.discount-invalid': 'لم يعد بالإمكان استعمال رمز التخفيض. احذفه من سلتك.',
    'storefront.checkout.error.checkout-unavailable': 'لم يعد المتجر يقترح هذا الاختيار.',
    'storefront.checkout.error.insufficient-stock': 'إحدى السلع لم تعد متوفرة بالكمية المطلوبة.',
    'storefront.checkout.error.too-many-requests': 'محاولات كثيرة. أعد المحاولة بعد دقائق.',
    'storefront.checkout.error.generic': 'تعذر إتمام الطلب. أعد المحاولة.',
    'storefront.order.title': 'شكرًا على طلبك!',
    'storefront.order.number': 'الطلب رقم {number}',
    'storefront.order.cashOnDelivery': 'ستدفع عند الاستلام: جهّز {total}.',
    'storefront.order.bankTransfer': 'يرجى تحويل {total}:',
    'storefront.order.pickup': 'الاستلام من المتجر: سيتصل بك المتجر عندما يكون طلبك جاهزًا.',
    'storefront.order.shippingTo': 'التوصيل إلى:',
    'storefront.order.contact': 'سيتصل بك المتجر على الرقم {phone}.',
    'storefront.order.keep': 'احتفظ بعنوان هذه الصفحة: يمكّنك من رؤية طلبك مجددًا.',
    'storefront.order.view': 'عرض طلبي',
    'storefront.order.notFound': 'الطلب غير موجود.',
    // --- module 11: order management, invoices ---
    'email.orderStatus.confirmed.subject': 'أكّد {store} الطلب رقم {number}',
    'email.orderStatus.confirmed.heading': 'تم تأكيد طلبك',
    'email.orderStatus.confirmed.intro': 'أكّد {store} طلبك رقم {number} ويقوم بتجهيزه.',
    'email.orderStatus.shipped.subject': 'تم شحن الطلب رقم {number} – {store}',
    'email.orderStatus.shipped.heading': 'طلبك في الطريق',
    'email.orderStatus.shipped.intro': 'شحن {store} طلبك رقم {number}.',
    'email.orderStatus.delivered.subject': 'تم تسليم الطلب رقم {number} – {store}',
    'email.orderStatus.delivered.heading': 'تم تسليم طلبك',
    'email.orderStatus.delivered.intro': 'تم تسليم طلبك رقم {number} من {store}. شكرًا لك!',
    'email.orderStatus.cancelled.subject': 'تم إلغاء الطلب رقم {number} – {store}',
    'email.orderStatus.cancelled.heading': 'تم إلغاء طلبك',
    'email.orderStatus.cancelled.intro': 'ألغى {store} طلبك رقم {number}. تواصل مع المتجر لأي استفسار.',
    'email.orderStatus.tracking': 'التتبع: {note}',
    'invoice.title': 'فاتورة',
    'invoice.number': 'رقم {number}',
    'invoice.date': 'التاريخ: {date}',
    'invoice.order': 'الطلب رقم {number} بتاريخ {date}',
    'invoice.taxId': 'المعرّف الجبائي: {taxId}',
    'invoice.billTo': 'الحريف',
    'invoice.payment': 'الدفع والتوصيل',
    'invoice.paymentMethod.cash_on_delivery': 'الدفع عند الاستلام',
    'invoice.paymentMethod.bank_transfer': 'تحويل بنكي',
    'invoice.delivery.shipping': 'التوصيل إلى المنزل',
    'invoice.delivery.pickup': 'الاستلام من المتجر',
    'invoice.column.item': 'البيان',
    'invoice.column.quantity': 'الكمية',
    'invoice.column.unitPrice': 'سعر الوحدة',
    'invoice.column.discount': 'التخفيض',
    'invoice.column.total': 'المبلغ',
    'invoice.subtotal': 'المجموع الفرعي',
    'invoice.discount': 'التخفيض',
    'invoice.discountCode': 'التخفيض ({code})',
    'invoice.shipping': 'التوصيل',
    'invoice.fee': 'معلوم',
    'invoice.tax': 'الأداء على القيمة المضافة',
    'invoice.taxIncluded': 'منها الأداء',
    'invoice.taxLine': 'أداء {rate}٪ على {net}: {tax}',
    'invoice.total': 'المجموع',
    'admin.inventory.reason.cancelled': 'طلب ملغى',
    'admin.order.status': 'الحالة',
    'admin.order.status.placed': 'جديد',
    'admin.order.status.confirmed': 'مؤكد',
    'admin.order.status.shipped': 'تم الشحن',
    'admin.order.status.delivered': 'تم التسليم',
    'admin.order.status.cancelled': 'ملغى',
    'admin.order.status.returned': 'مُرجع',
    'admin.order.paymentStatus.refunded': 'مسترجع',
    'admin.order.filter.allStatuses': 'كل الحالات',
    'admin.order.filter.allPayments': 'كل الدفوعات',
    'admin.order.actions': 'الإجراءات',
    'admin.order.noActions': 'لا يوجد إجراء ممكن: الطلب مغلق.',
    'admin.order.action.confirm': 'تأكيد الطلب',
    'admin.order.action.ship': 'تسجيل الشحن',
    'admin.order.action.deliver': 'تسجيل التسليم',
    'admin.order.action.cancel': 'إلغاء الطلب',
    'admin.order.action.return': 'تسجيل إرجاع',
    'admin.order.action.mark-paid': 'تسجيل الدفع',
    'admin.order.action.refund': 'تسجيل الاسترجاع',
    'admin.order.trackingNote': 'معلومات التتبع للحريف (اختياري)',
    'admin.order.trackingNoteHint': 'شركة النقل، رقم التتبع… يُرسل إلى الحريف بالبريد.',
    'admin.order.actionNote': 'ملاحظة داخلية (اختياري)',
    'admin.order.cancelHint': 'تعود السلع المتابعة في المخزون إلى البيع.',
    'admin.order.returnHint': 'حدّد ما يعود إلى المخزون؛ تبقى السلع التالفة خارجه.',
    'admin.order.restockOf': 'إعادة إلى المخزون: {title}',
    'admin.order.apply': 'تأكيد',
    'admin.order.updated': 'تم تحديث الطلب.',
    'admin.order.error.invalid-transition': 'لم يعد هذا التغيير ممكنًا. أعد تحميل الصفحة.',
    'admin.order.error.version-conflict': 'تم تغيير الطلب في الأثناء. أعد تحميل الصفحة.',
    'admin.order.error.invoice-settings-missing': 'أدخل أولًا الاسم القانوني والعنوان في إعدادات الفوترة.',
    'admin.order.error.invoice-exists': 'الفاتورة موجودة.',
    'admin.order.tracking': 'التتبع: {note}',
    'admin.order.history': 'السجل',
    'admin.order.history.placed': 'تم تقديم الطلب',
    'admin.order.history.status': 'الحالة: {from} ← {to}',
    'admin.order.history.payment': 'الدفع: {from} ← {to}',
    'admin.order.history.note': 'ملاحظة',
    'admin.order.history.invoice': 'تم إصدار الفاتورة {number}',
    'admin.order.history.restocked': '{count, plural, zero {لا سلعة أعيدت إلى المخزون} one {سلعة واحدة أعيدت إلى المخزون} two {سلعتان أعيدتا إلى المخزون} few {# سلع أعيدت إلى المخزون} many {# سلعة أعيدت إلى المخزون} other {# سلعة أعيدت إلى المخزون}}',
    'admin.order.noteLabel': 'ملاحظة داخلية',
    'admin.order.addNote': 'إضافة الملاحظة',
    'admin.order.noteAdded': 'تمت إضافة الملاحظة.',
    'admin.order.invoice': 'الفاتورة',
    'admin.order.invoiceNone': 'لم تصدر أي فاتورة.',
    'admin.order.invoiceLanguage': 'لغة الفاتورة',
    'admin.order.issueInvoice': 'إصدار الفاتورة',
    'admin.order.invoiceIssued': 'تم إصدار الفاتورة.',
    'admin.order.downloadInvoice': 'تنزيل الفاتورة {number} (PDF)',
    'admin.invoice.title': 'الفوترة',
    'admin.invoice.intro': 'تُطبع هذه المعلومات كما هي على فواتيرك. أنت مسؤول عن صحتها وعن البيانات الإجبارية؛ لا يضيف beinstore أي صيغة قانونية.',
    'admin.invoice.legalNameIn': 'الاسم القانوني ({language})',
    'admin.invoice.addressIn': 'العنوان ({language})',
    'admin.invoice.taxId': 'المعرّف الجبائي (اختياري)',
    'admin.invoice.footerIn': 'نص أسفل الصفحة ({language}، اختياري)',
    'admin.invoice.prefix': 'بادئة الأرقام (اختياري)',
    'admin.invoice.prefixHint': 'حروف وأرقام و / و - (12 على الأكثر)، مثل FA-. الأرقام متتالية دون فجوات.',
    'admin.invoice.invalidPrefix': 'بادئة غير صالحة.',
    'admin.invoice.saved': 'تم حفظ إعدادات الفوترة.',
    'admin.invoice.error.validation': 'تحقق من الحقول المشار إليها.',
    'admin.invoice.error.version-conflict': 'تم تغيير الإعدادات في الأثناء. أعد تحميل الصفحة.',
    'storefront.order.status': 'الحالة: {status}',
    'storefront.order.status.placed': 'مستلم، في انتظار التأكيد',
    'storefront.order.status.confirmed': 'مؤكد، قيد التجهيز',
    'storefront.order.status.shipped': 'تم الشحن',
    'storefront.order.status.delivered': 'تم التسليم',
    'storefront.order.status.cancelled': 'ملغى',
    'storefront.order.status.returned': 'مُرجع',
    'storefront.order.tracking': 'التتبع: {note}',
    // --- module 16: private apps and webhooks ---
    'admin.integrations.title': 'التطبيقات والإشعارات الآلية',
    'admin.integrations.intro': 'اربط أدواتك الخاصة (برنامج تسيير، نقطة بيع، جدول بيانات) بمتجرك.',
    'admin.integrations.apps': 'التطبيقات الخاصة',
    'admin.integrations.appsIntro': 'يحصل كل تطبيق على رمز سري محدود بالصلاحيات المختارة. لا تسلمه إلا لمن تثق به.',
    'admin.integrations.appName': 'اسم التطبيق',
    'admin.integrations.scopes': 'الصلاحيات',
    'admin.integrations.scope.products.read': 'قراءة المنتجات',
    'admin.integrations.scope.inventory.read': 'قراءة المخزون',
    'admin.integrations.scope.inventory.write': 'تحديث المخزون',
    'admin.integrations.scope.orders.read': 'قراءة الطلبات (مع معطيات الحرفاء)',
    'admin.integrations.scope.orders.write': 'معالجة الطلبات (تأكيد، شحن، تسليم، إلغاء)',
    'admin.integrations.createApp': 'إنشاء التطبيق',
    'admin.integrations.tokenTitle': 'رمز «{name}»',
    'admin.integrations.tokenWarning': 'انسخ هذا الرمز الآن: لن يظهر مجددًا. أرسله في ترويسة Authorization: Bearer.',
    'admin.integrations.noApps': 'لا توجد تطبيقات.',
    'admin.integrations.column.name': 'الاسم',
    'admin.integrations.column.scopes': 'الصلاحيات',
    'admin.integrations.column.token': 'الرمز',
    'admin.integrations.column.lastUsed': 'آخر استعمال',
    'admin.integrations.column.status': 'الحالة',
    'admin.integrations.column.result': 'النتيجة',
    'admin.integrations.never': 'أبدًا',
    'admin.integrations.appStatus.active': 'مفعّل',
    'admin.integrations.appStatus.revoked': 'ملغى',
    'admin.integrations.revoke': 'إلغاء {name}',
    'admin.integrations.revoked': 'تم إلغاء التطبيق: لم يعد رمزه يعمل.',
    'admin.integrations.webhooks': 'الإشعارات الآلية (Webhooks)',
    'admin.integrations.webhooksIntro': 'يرسل beinstore طلب POST موقّعًا إلى عنوانك عند كل حدث مختار. تحقق من التوقيع بسر العنوان.',
    'admin.integrations.webhooksDisabled': 'لم يتم إعداد الإشعارات الآلية على المنصة بعد.',
    'admin.integrations.url': 'عنوان الاستقبال (https)',
    'admin.integrations.events': 'الأحداث',
    'admin.integrations.event.order.placed': 'تقديم طلب',
    'admin.integrations.event.order.status_changed': 'تغيير حالة الطلب',
    'admin.integrations.event.order.payment_changed': 'تغيير دفع الطلب',
    'admin.integrations.event.product.created': 'إنشاء منتج',
    'admin.integrations.event.product.updated': 'تعديل منتج',
    'admin.integrations.event.product.deleted': 'حذف منتج',
    'admin.integrations.event.inventory.availability_changed': 'تغيير التوفر',
    'admin.integrations.event.invoice.issued': 'إصدار فاتورة',
    'admin.integrations.addEndpoint': 'إضافة العنوان',
    'admin.integrations.noEndpoints': 'لا توجد عناوين.',
    'admin.integrations.endpointStatus.active': 'مفعّل',
    'admin.integrations.endpointStatus.disabled': 'معطّل',
    'admin.integrations.disabledByFailures': 'معطّل بعد إخفاقات متكررة',
    'admin.integrations.secret': 'سر التوقيع',
    'admin.integrations.showSecret': 'عرض السر',
    'admin.integrations.rotateSecret': 'تغيير السر',
    'admin.integrations.rotated': 'سر جديد: لم يعد السابق يعمل.',
    'admin.integrations.ping': 'إرسال تجربة',
    'admin.integrations.pinged': 'تمت جدولة التجربة.',
    'admin.integrations.disable': 'تعطيل',
    'admin.integrations.enable': 'إعادة التفعيل',
    'admin.integrations.delete': 'حذف',
    'admin.integrations.deliveries': 'عرض الإرسالات',
    'admin.integrations.noDeliveries': 'لا توجد إرسالات.',
    'admin.integrations.delivery.pending': 'في الانتظار',
    'admin.integrations.delivery.succeeded': 'ناجح',
    'admin.integrations.delivery.failed': 'فاشل',
    'admin.integrations.attempts': '{count, plural, zero {لا محاولة} one {محاولة واحدة} two {محاولتان} few {# محاولات} many {# محاولة} other {# محاولة}}',
    'admin.integrations.redeliver': 'إعادة الإرسال',
    'admin.integrations.redelivered': 'تمت إعادة جدولة الإرسال.',
    'admin.integrations.error.app': 'أدخل اسمًا وصلاحية واحدة على الأقل.',
    'admin.integrations.error.endpoint': 'أدخل عنوانًا وحدثًا واحدًا على الأقل.',
    'admin.integrations.error.url-scheme': 'استعمل عنوان https.',
    'admin.integrations.error.url-credentials': 'يجب ألا يحتوي العنوان على معرّفات دخول.',
    'admin.integrations.error.url-address': 'هذا العنوان غير مسموح به (شبكة خاصة أو محلية).',
    'admin.integrations.error.url-invalid': 'عنوان غير صالح.',
    'admin.integrations.error.limit': 'تم بلوغ الحد: احذف أو ألغِ عنصرًا أولًا.',
    'admin.integrations.error.version-conflict': 'تم تغيير العنوان في الأثناء. أعد تحميل الصفحة.',
    // --- module 17: analytics, customer data ---
    'admin.analytics.title': 'الإحصائيات',
    'admin.analytics.definition': 'المبيعات = الطلبات غير الملغاة وغير المرجعة (المبلغ الكامل مع التوصيل والمعاليم). التواريخ بتوقيت تونس.',
    'admin.analytics.from': 'من',
    'admin.analytics.to': 'إلى',
    'admin.analytics.granularity': 'التجميع حسب',
    'admin.analytics.granularity.day': 'اليوم',
    'admin.analytics.granularity.week': 'الأسبوع',
    'admin.analytics.granularity.month': 'الشهر',
    'admin.analytics.exportOrders': 'تصدير طلبات الفترة (CSV)',
    'admin.analytics.revenue': 'المبيعات',
    'admin.analytics.orders': 'الطلبات',
    'admin.analytics.averageBasket': 'متوسط السلة',
    'admin.analytics.change': '{percent}٪ مقارنة بالفترة السابقة',
    'admin.analytics.noComparison': 'لا توجد فترة سابقة للمقارنة',
    'admin.analytics.sales': 'المبيعات حسب الفترة',
    'admin.analytics.chartLabel': 'المبيعات من {from} إلى {to}: {total}',
    'admin.analytics.showTable': 'عرض الأرقام',
    'admin.analytics.period': 'الفترة',
    'admin.analytics.topProducts': 'الأكثر مبيعًا',
    'admin.analytics.noSales': 'لا توجد مبيعات في هذه الفترة.',
    'admin.analytics.byGovernorate': 'المبيعات حسب الولاية',
    'admin.analytics.region': 'الولاية',
    'admin.analytics.share': 'نسبة الطلبات',
    'admin.analytics.funnel': 'متابعة الطلبات',
    'admin.analytics.payments': 'المقبوضات',
    'admin.analytics.range': 'الفترة',
    'admin.analytics.preset.7d': 'آخر 7 أيام',
    'admin.analytics.preset.30d': 'آخر 30 يومًا',
    'admin.analytics.preset.90d': 'آخر 90 يومًا',
    'admin.analytics.preset.month': 'هذا الشهر',
    'admin.analytics.itemsSold': 'قطع مباعة',
    'admin.analytics.cancelled': 'الإلغاءات',
    'admin.analytics.returned': 'المرتجعات',
    'admin.analytics.outcomes': 'الطلبات والإلغاءات والمرتجعات',
    'admin.analytics.outcomesLabel': 'الطلبات والإلغاءات والمرتجعات من {from} إلى {to}',
    'admin.analytics.catalog': 'الكتالوج',
    'admin.analytics.overview': 'نظرة على المتجر',
    'admin.analytics.seeDashboard': 'فتح لوحة المتابعة',
    'admin.privacy.title': 'بيانات الحرفاء',
    'admin.privacy.intro': 'استجب لطلبات حرفائك: ابحث عن طلباتهم أو صدّر بياناتهم أو امحُها. يحذف المحو الاسم والهاتف والبريد والعنوان والملاحظة؛ وتبقى المبالغ والفواتير الصادرة.',
    'admin.privacy.identifier': 'البحث حسب',
    'admin.privacy.search': 'بحث',
    'admin.privacy.found': '{count, plural, =0 {لا يوجد طلب يحتوي على بيانات هذا الحريف.} one {طلب واحد يحتوي على بيانات هذا الحريف.} two {طلبان يحتويان على بيانات هذا الحريف.} few {# طلبات تحتوي على بيانات هذا الحريف.} many {# طلبًا يحتوي على بيانات هذا الحريف.} other {# طلب يحتوي على بيانات هذا الحريف.}}',
    'admin.privacy.export': 'تصدير البيانات (JSON)',
    'admin.privacy.exported': 'تم تصدير البيانات.',
    'admin.privacy.eraseHint': 'يجب أن تكون الطلبات مسلّمة أو ملغاة أو مُرجعة قبل المحو. لا يمكن التراجع عن ذلك.',
    'admin.privacy.erase': 'محو البيانات',
    'admin.privacy.confirm': 'أؤكد المحو النهائي للبيانات الشخصية لهذا الحريف',
    'admin.privacy.erased': '{count, plural, zero {لم تُمحَ بيانات أي طلب.} one {تم محو البيانات من طلب واحد.} two {تم محو البيانات من طلبين.} few {تم محو البيانات من # طلبات.} many {تم محو البيانات من # طلبًا.} other {تم محو البيانات من # طلب.}}',
    'admin.privacy.log': 'سجل الطلبات',
    'admin.privacy.noLog': 'لا توجد طلبات.',
    'admin.privacy.kind.export': 'تصدير',
    'admin.privacy.kind.erase': 'محو',
    'admin.privacy.kind.retention': 'مدة الحفظ',
    'admin.privacy.ordersAffected': '{count, plural, zero {لا طلب} one {طلب واحد} two {طلبان} few {# طلبات} many {# طلبًا} other {# طلب}}',
    'admin.privacy.error.inProgress': 'بعض الطلبات ما زالت قيد المعالجة. {detail}',
    'admin.privacy.error.identifier': 'رقم أو بريد غير صالح.',
    'admin.privacy.erasedCustomer': 'حريف ممحو',
    'admin.privacy.erasedOn': 'تم محو بيانات الحريف بتاريخ {date}.',
    // --- module 14: cash-on-delivery management ---
    'email.order.respond': 'تأكيد طلبي',
    'email.order.view': 'متابعة طلبي',
    'email.order.respondHint': 'يرجى تأكيد طلبك حتى يجهّزه المتجر.',
    'storefront.order.respondIntro': 'الدفع عند الاستلام: أكّد طلبك حتى يجهّزه المتجر.',
    'storefront.order.confirm': 'أؤكد طلبي',
    'storefront.order.cancel': 'إلغاء طلبي',
    'storefront.order.confirmed': 'شكرًا، تم تأكيد طلبك.',
    'storefront.order.cancelled': 'تم إلغاء طلبك.',
    'storefront.order.actionFailed': 'لم يعد بالإمكان تعديل هذا الطلب من هنا.',
    'admin.cod.title': 'الدفع عند الاستلام',
    'admin.cod.intro': 'تأكيد الطلبات والإلغاء التلقائي والأرقام المرفوضة.',
    'admin.cod.customerConfirmation': 'يؤكد الحريف طلبه من صفحة الطلب والبريد الإلكتروني، ويمكنه إلغاؤه بعد التأكيد',
    'admin.cod.autoCancelHours': 'إلغاء الطلبات غير المؤكدة بعد (ساعات)',
    'admin.cod.autoCancelHint': 'اتركه فارغًا لعدم الإلغاء التلقائي أبدًا. يُعاد المخزون ويتلقى الحريف بريد الإلغاء.',
    'admin.cod.refusalThreshold': 'التنبيه على رقم ابتداءً من هذا العدد من الطلبات المرجعة',
    'admin.cod.refusalHint': 'يُحسب على طلبات متجرك فقط. اتركه فارغًا لعدم التنبيه.',
    'admin.cod.saved': 'تم حفظ الإعدادات.',
    'admin.cod.blocked.title': 'أرقام مرفوضة للدفع عند الاستلام',
    'admin.cod.blocked.hint': 'لم يعد بإمكان هذه الأرقام اختيار الدفع عند الاستلام في متجرك. تُحفظ الأرقام الأخيرة فقط.',
    'admin.cod.blocked.none': 'لا توجد أرقام.',
    'admin.cod.blocked.entry': 'رقم ينتهي بـ {hint}',
    'admin.cod.blocked.phone': 'رقم الهاتف',
    'admin.cod.blocked.reason': 'السبب (اختياري)',
    'admin.cod.blocked.add': 'حظر هذا الرقم',
    'admin.cod.blocked.remove': 'إلغاء حظر الرقم المنتهي بـ {hint}',
    'admin.cod.panel': 'متابعة الدفع عند الاستلام',
    'admin.cod.firstOrder': 'أول طلب من هذا الرقم في متجرك.',
    'admin.cod.pastOrders': 'طلبات أخرى من هذا الرقم: {delivered} مسلّمة، {returned} مرجعة، {cancelled} ملغاة، {inProgress} قيد المعالجة.',
    'admin.cod.warning': 'تنبيه: {returned, plural, zero {لا طلبات مرجعة} one {طلب مرجع واحد} two {طلبان مرجعان} few {# طلبات مرجعة} many {# طلبًا مرجعًا} other {# طلب مرجع}} لهذا الرقم.',
    'admin.cod.isBlocked': 'هذا الرقم مرفوض للدفع عند الاستلام.',
    'admin.cod.calls': '{count, plural, zero {لا توجد مكالمات مسجلة.} one {مكالمة واحدة مسجلة.} two {مكالمتان مسجلتان.} few {# مكالمات مسجلة.} many {# مكالمة مسجلة.} other {# مكالمة مسجلة.}}',
    'admin.cod.logCall': 'تسجيل المكالمة',
    'admin.cod.outcome': 'نتيجة المكالمة',
    'admin.cod.outcome.confirmed': 'أكّدها الحريف',
    'admin.cod.outcome.declined': 'رفضها الحريف',
    'admin.cod.outcome.no_answer': 'لا رد',
    'admin.cod.outcome.unreachable': 'رقم غير متاح أو خاطئ',
    'admin.cod.outcome.callback': 'إعادة الاتصال لاحقًا',
    'admin.cod.outcomeHint': '«أكّدها الحريف» يؤكد الطلب؛ «رفضها الحريف» يلغيه ويعيد المخزون.',
    'admin.cod.callNote': 'ملاحظة (اختياري)',
    'admin.cod.callLogged': 'تم تسجيل المكالمة.',
    'admin.cod.block': 'رفض الدفع عند الاستلام لهذا الرقم',
    'admin.cod.unblock': 'قبول هذا الرقم من جديد',
    'admin.cod.blockedDone': 'تم رفض الرقم للدفع عند الاستلام.',
    'admin.cod.unblockedDone': 'تم قبول الرقم من جديد.',
    'admin.cod.error.phone': 'رقم هاتف غير صالح.',
    'admin.cod.history.call': 'مكالمة: {outcome}',
    'admin.order.history.byCustomer': 'من طرف الحريف',
    'admin.order.history.automatic': 'تلقائيًا',
    // --- module 13: shipping by settings ---
    'email.shipment.carrier': 'شركة النقل: {carrier}',
    'email.shipment.line': '{carrier} — رقم التتبع: {tracking}',
    'email.shipment.ownDelivery': 'توصيل من المتجر',
    'email.shipment.track': 'تتبع طردي',
    'email.shipment.subject': 'طرد آخر من طلبك رقم {number} في الطريق – {store}',
    'email.shipment.heading': 'طرد آخر في الطريق',
    'email.shipment.intro': 'أرسل {store} جزءًا آخر من طلبك رقم {number}.',
    'deliveryNote.title': 'وصل التسليم',
    'deliveryNote.reference': 'المرجع: {reference}',
    'deliveryNote.date': 'التاريخ: {date}',
    'deliveryNote.recipient': 'المرسل إليه',
    'deliveryNote.carrier': 'شركة النقل',
    'deliveryNote.ownDelivery': 'توصيل من المتجر',
    'deliveryNote.tracking': 'رقم التتبع: {tracking}',
    'deliveryNote.collect': 'المبلغ المطلوب عند التسليم: {amount}',
    'deliveryNote.nothingToCollect': 'لا شيء للتحصيل عند التسليم',
    'deliveryNote.column.item': 'المنتج',
    'deliveryNote.column.quantity': 'الكمية',
    'deliveryNote.customerNote': 'ملاحظة الحريف',
    'storefront.order.shipments': 'الطرود',
    'storefront.order.shipment': 'الطرد {number}',
    'storefront.order.shipment.shipped': 'في الطريق',
    'storefront.order.shipment.delivered': 'تم تسليمه',
    'storefront.order.shipment.returned': 'مُرجع',
    'storefront.order.shipment.ownDelivery': 'توصيل من المتجر',
    'storefront.order.shipment.tracking': 'رقم التتبع: {tracking}',
    'storefront.order.shipment.track': 'تتبع الطرد {number}',
    'admin.carriers.title': 'شركات النقل',
    'admin.carriers.intro': 'شركات النقل التي تتعامل معها. لا يوجد ربط مع أنظمتها: تُدخل رقم التتبع عند الإرسال.',
    'admin.carriers.none': 'لا توجد شركات نقل.',
    'admin.carriers.name': 'الاسم',
    'admin.carriers.phone': 'الهاتف (اختياري)',
    'admin.carriers.trackingUrl': 'رابط التتبع (اختياري)',
    'admin.carriers.trackingUrlHint': 'يبدأ بـ https:// ويحتوي على {placeholder} الذي يُستبدل برقم التتبع.',
    'admin.carriers.defaultFee': 'المعلوم المعتاد لكل طرد (د.ت، اختياري)',
    'admin.carriers.active': 'اقتراح شركة النقل هذه عند الإرسال',
    'admin.carriers.add': 'إضافة شركة النقل',
    'admin.carriers.edit': 'تعديل {name}',
    'admin.carriers.added': 'تمت إضافة شركة النقل.',
    'admin.carriers.saved': 'تم حفظ شركة النقل.',
    'admin.carriers.inactive': 'غير مفعّل',
    'admin.carriers.error.conflict': 'توجد شركة نقل بهذا الاسم (أو تم بلوغ الحد).',
    'admin.carriers.error.validation': 'تحقق من الاسم والهاتف ورابط التتبع والمعلوم.',
    'admin.shipment.title': 'الطرود',
    'admin.shipment.none': 'لم يُرسل أي طرد.',
    'admin.shipment.number': 'الطرد {number}',
    'admin.shipment.ownDelivery': 'توصيل من المتجر',
    'admin.shipment.status.shipped': 'في الطريق',
    'admin.shipment.status.delivered': 'تم التسليم',
    'admin.shipment.status.returned': 'مُرجع',
    'admin.shipment.tracking': 'التتبع: {tracking}',
    'admin.shipment.cod': 'للتحصيل: {amount}',
    'admin.shipment.fee': 'معلوم النقل: {amount}',
    'admin.shipment.items': '{count, plural, zero {لا منتجات} one {منتج واحد} two {منتجان} few {# منتجات} many {# منتجًا} other {# منتج}}',
    'admin.shipment.markDelivered': 'تأشير الطرد {number} كمسلّم',
    'admin.shipment.markReturned': 'تأشير الطرد {number} كمُرجع',
    'admin.shipment.note': 'وصل تسليم الطرد {number} ({language})',
    'admin.shipment.new': 'إرسال طرد',
    'admin.shipment.quantity': 'الكمية المراد إرسالها: {item}',
    'admin.shipment.left': 'المتبقي {count}',
    'admin.shipment.carrier': 'شركة النقل',
    'admin.shipment.trackingNumber': 'رقم التتبع (اختياري)',
    'admin.shipment.feeLabel': 'معلوم النقل (د.ت، اختياري)',
    'admin.shipment.feeHint': 'فارغ: المعلوم المعتاد لشركة النقل.',
    'admin.shipment.codLabel': 'المبلغ المطلوب عند التسليم (د.ت، اختياري)',
    'admin.shipment.codHint': 'فارغ: كل المبلغ المتبقي.',
    'admin.shipment.create': 'إرسال',
    'admin.shipment.created': 'تم تسجيل الطرد.',
    'admin.shipment.updated': 'تم تحديث الطرد.',
    'admin.shipment.error.validation': 'تحقق من الكميات (لا أكثر من المتبقي) ورقم التتبع والمبالغ (لا أكثر من المتبقي للتحصيل).',
    'admin.shipment.error.empty': 'اختر منتجًا واحدًا على الأقل.',
    'admin.order.history.shipment': 'الطرد {number}: {status}',
    // --- module 12: cash-on-delivery payments ---
    'admin.cash.title': 'المقبوضات',
    'admin.cash.total': 'مجموع الطلب: {amount}',
    'admin.cash.collected': 'المقبوض: {amount}',
    'admin.cash.refunded': 'المسترجع: {amount}',
    'admin.cash.due': 'المتبقي للتحصيل: {amount}',
    'admin.cash.none': 'لا توجد مقبوضات.',
    'admin.cash.kind.collection': 'قبض',
    'admin.cash.kind.refund': 'استرجاع',
    'admin.cash.kind.reversal': 'إلغاء',
    'admin.cash.byCarrier': 'عن طريق {carrier}',
    'admin.cash.byMerchant': 'عن طريق المتجر',
    'admin.cash.parcel': 'الطرد {number}',
    'admin.cash.automatic': 'تلقائي',
    'admin.cash.reversed': 'ملغى',
    'admin.cash.remitted': 'سلّمه الناقل',
    'admin.cash.reverse': 'إلغاء قيد {date}',
    'admin.cash.reversedDone': 'تم إلغاء القيد.',
    'admin.cash.collect': 'تسجيل قبض',
    'admin.cash.amount': 'المبلغ (د.ت)',
    'admin.cash.collector': 'قبضه',
    'admin.cash.merchant': 'المتجر',
    'admin.cash.note': 'ملاحظة (اختياري)',
    'admin.cash.collectedDone': 'تم تسجيل القبض.',
    'admin.cash.refund': 'تسجيل استرجاع',
    'admin.cash.refundedDone': 'تم تسجيل الاسترجاع.',
    'admin.cash.error.amount': 'مبلغ غير صالح: لا يتجاوز المتبقي للتحصيل (أو المقبوض، في حالة الاسترجاع).',
    'admin.cash.error.reverse': 'لا يمكن إلغاء هذا القيد (ملغى مسبقًا، أو سلّم الناقل المبلغ: سجّل استرجاعًا).',
    'admin.payments.title': 'المقبوضات والناقلون',
    'admin.payments.intro': 'الدفع عند الاستلام: يسلّمك الناقلون المبالغ المقبوضة بعد خصم معاليمهم.',
    'admin.payments.inHand': 'في الصندوق: {amount}',
    'admin.payments.withCarriers': 'لدى الناقلين: {amount}',
    'admin.payments.owed': '{name} مدين لك بـ {amount} ({count, plural, zero {لا مقبوضات} one {قبض واحد} two {قبضان} few {# مقبوضات} many {# قبضًا} other {# قبض}})',
    'admin.payments.lastRemittance': 'آخر تسليم: {date}',
    'admin.payments.remit': 'تسجيل تسليم من {name}',
    'admin.payments.order': 'الطلب رقم {number}',
    'admin.payments.fees': 'المعاليم التي احتفظ بها الناقل (د.ت)',
    'admin.payments.feesHint': 'المقترح: معاليم الطرود ({amount}).',
    'admin.payments.receivedAt': 'تاريخ التسليم',
    'admin.payments.net': 'المبلغ المستلم: {amount}',
    'admin.payments.save': 'تسجيل التسليم',
    'admin.payments.saved': 'تم تسجيل التسليم.',
    'admin.payments.history': 'عمليات التسليم',
    'admin.payments.remittance': '{date} — {name}: استلام {net} ({gross} مقبوضة، {fees} معاليم)',
    'admin.payments.none': 'لا توجد عمليات تسليم.',
    'admin.payments.nothingOwed': 'لا شيء معلق لدى هذا الناقل.',
    'admin.payments.error.select': 'اختر قبضًا واحدًا على الأقل.',
    'admin.payments.error.stale': 'لم تعد هذه المقبوضات معلقة: أعد تحميل الصفحة.',
    // --- module 15: billing, custom domains, operator console ---
    'platformInvoice.title': 'فاتورة',
    'platformInvoice.taxId': 'المعرف الجبائي: {taxId}',
    'platformInvoice.number': 'رقم {number}',
    'platformInvoice.date': 'التاريخ: {date}',
    'platformInvoice.billTo': 'الفوترة إلى',
    'platformInvoice.column.description': 'البيان',
    'platformInvoice.column.amount': 'المبلغ',
    'platformInvoice.line': 'اشتراك {plan} — {months} أشهر، من {from} إلى {to}',
    'platformInvoice.net': 'المجموع دون الأداء على القيمة المضافة',
    'platformInvoice.vat': 'الأداء على القيمة المضافة {rate}٪',
    'platformInvoice.total': 'المجموع',
    'platformInvoice.paid': 'دُفع عن طريق {method} بتاريخ {date}',
    'platformInvoice.method.bank_transfer': 'تحويل بنكي',
    'platformInvoice.method.cash': 'نقدًا',
    'platformInvoice.method.other': 'وسيلة أخرى',
    'platformInvoice.reference': 'المرجع: {reference}',
    'admin.error.subscription-restricted': 'اشتراك غير مدفوع: يمكن تعديل الطلبات فقط إلى حين الدفع.',
    'admin.error.plan-limit-reached': 'تم بلوغ حد باقتك: انتقل إلى باقة أعلى لإضافة المزيد.',
    'admin.billing.title': 'الاشتراك',
    'admin.billing.none': 'ليس لمتجرك باقة حاليًا.',
    'admin.billing.plan': 'الباقة: {name}',
    'admin.billing.price': '{amount} كل {months, plural, zero {# شهر} one {شهر} two {شهرين} few {# أشهر} many {# شهرًا} other {# شهر}}',
    'admin.billing.state.none': 'بدون اشتراك.',
    'admin.billing.state.free': 'باقة مجانية.',
    'admin.billing.state.trialing': 'تجربة مجانية حتى {date}.',
    'admin.billing.state.active': 'مدفوع حتى {date}.',
    'admin.billing.state.grace': 'الدفع متأخر: ستصبح الإدارة للقراءة فقط بتاريخ {date} (تبقى الطلبات تعمل).',
    'admin.billing.state.restricted': 'اشتراك غير مدفوع: الإدارة للقراءة فقط، باستثناء الطلبات، إلى حين الدفع.',
    'admin.billing.howToPay': 'يسجّل فريق beinstore المدفوعات، ثم تظهر الفاتورة هنا.',
    'admin.billing.usage': 'الاستعمال',
    'admin.billing.kind.products': 'المنتجات',
    'admin.billing.kind.staff': 'أعضاء الفريق',
    'admin.billing.kind.customDomains': 'النطاقات الخاصة',
    'admin.billing.usageLine': '{kind}: {used} من {limit}',
    'admin.billing.usageUnlimited': '{kind}: {used} (غير محدود)',
    'admin.billing.invoices': 'فواتير beinstore',
    'admin.billing.noInvoices': 'لا توجد فواتير.',
    'admin.billing.invoice': 'الفاتورة {number} بتاريخ {date} — {amount} (PDF)',
    'admin.billing.details': 'عرض الاشتراك',
    'admin.domains.title': 'عناوين المتجر',
    'admin.domains.intro': 'يبقى متجرك متاحًا دائمًا على عنوانه في beinstore. يمكنك أيضًا استعمال اسم نطاقك الخاص.',
    'admin.domains.unavailable': 'النطاقات الخاصة غير متاحة بعد على المنصة.',
    'admin.domains.kind.platform_subdomain': 'عنوان beinstore',
    'admin.domains.kind.custom': 'نطاق خاص',
    'admin.domains.status.pending_verification': 'في انتظار التحقق',
    'admin.domains.status.active': 'مفعّل',
    'admin.domains.canonical': 'العنوان الرئيسي',
    'admin.domains.host': 'اسم النطاق (مثال: shop.example.tn)',
    'admin.domains.add': 'إضافة النطاق',
    'admin.domains.added': 'تمت إضافة النطاق: أنشئ سجلات DNS ثم تحقق.',
    'admin.domains.instructions': 'أنشئ هذه السجلات لدى مزوّد نطاقك:',
    'admin.domains.txt': 'سجل TXT {name} = {value}',
    'admin.domains.cname': 'سجل CNAME {name} → {target}',
    'admin.domains.verify': 'التحقق من {host}',
    'admin.domains.verified': 'تم التحقق من النطاق.',
    'admin.domains.makeCanonical': 'استعمال {host} كعنوان رئيسي',
    'admin.domains.canonicalDone': 'تم تغيير العنوان الرئيسي.',
    'admin.domains.remove': 'إزالة {host}',
    'admin.domains.removed': 'تمت إزالة النطاق.',
    'admin.domains.error.notVerified': 'لم يتم العثور على سجل التحقق. قد تستغرق تغييرات DNS بعض الوقت.',
    'admin.domains.error.invalid': 'اسم نطاق غير صالح (يجب أن يكون خارج نطاق المنصة).',
    'admin.domains.error.taken': 'هذا النطاق مستعمل.',
    'admin.nav.operator': 'وحدة تحكم المشغّل',
    'admin.operator.title': 'وحدة تحكم المشغّل',
    'admin.operator.stores': 'المتاجر',
    'admin.operator.plans': 'الباقات',
    'admin.operator.settings': 'إعدادات الفوترة',
    'admin.console.tagline': 'الباقات والاشتراكات والفواتير لكل متاجر بي إن ستور.',
    'admin.console.note': 'مخصّص لمشغّلي منصة بي إن ستور.',
    'admin.landing.title': 'الصفحة الرئيسية',
    'admin.landing.intro': 'نصوص الصفحة العامة beinstore.tn. الباقات هي المعروضة عند التسجيل. العناصر الفارغة لا تظهر.',
    'admin.landing.language': 'لغة التحرير',
    'admin.landing.features': 'المزايا',
    'admin.landing.feature': 'الميزة {number}',
    'admin.landing.featureTitle': 'العنوان ({language})',
    'admin.landing.featureText': 'النص ({language})',
    'admin.landing.addFeature': 'إضافة ميزة',
    'admin.landing.faq': 'الأسئلة والأجوبة',
    'admin.landing.question': 'السؤال {number}',
    'admin.landing.questionText': 'السؤال ({language})',
    'admin.landing.answer': 'الجواب ({language})',
    'admin.landing.addQuestion': 'إضافة سؤال',
    'admin.landing.remove': 'حذف',
    'admin.landing.links': 'الصفحات القانونية',
    'admin.landing.terms': 'شروط الاستخدام (العنوان)',
    'admin.landing.privacy': 'سياسة الخصوصية (العنوان)',
    'admin.landing.linkHint': 'عنوان https لصفحة تستضيفها. فارغ = بدون رابط.',
    'admin.landing.saved': 'تم حفظ الصفحة الرئيسية.',
    'admin.landing.invalid': 'تحقّق من النصوص والعناوين (https فقط).',
    'landing.title': 'بي إن ستور — متجرك الإلكتروني في تونس',
    'landing.skip': 'انتقل إلى المحتوى',
    'landing.language': 'اللغة',
    'landing.signIn': 'تسجيل الدخول',
    'landing.cta': 'أنشئ متجري',
    'landing.compare': 'قارن الباقات',
    'landing.plans': 'الباقات',
    'landing.noPlans': 'لا توجد باقة متاحة حاليًا.',
    'landing.choose': 'اختر هذه الباقة',
    'landing.chooseNamed': 'اختر باقة {name}',
    'landing.free': 'مجانية',
    'landing.price': '{amount} كل {months, plural, zero {# شهر} one {شهر} two {شهرين} few {# أشهر} many {# شهرًا} other {# شهر}}',
    'landing.trial': 'فترة تجريبية مجانية: {days, plural, zero {# يوم} one {يوم واحد} two {يومان} few {# أيام} many {# يومًا} other {# يوم}}',
    'landing.limit.products': 'المنتجات: {count}',
    'landing.limit.staff': 'أعضاء الفريق: {count}',
    'landing.limit.domains': 'النطاقات الخاصة: {count}',
    'landing.unlimited': 'غير محدود',
    'landing.features': 'المزايا',
    'landing.faq': 'الأسئلة والأجوبة',
    'landing.terms': 'شروط الاستخدام',
    'landing.privacy': 'سياسة الخصوصية',
    'landing.error': 'تعذّر تحميل الصفحة. حاول مرة أخرى بعد قليل.',
    'landing.menu': 'في هذه الصفحة',
    'landing.vision.title': 'الرؤية',
    'landing.vision.body': 'يجب أن يتمكّن كل متجر في تونس من استلام الطلب وتوصيله وتحصيل ثمنه في مكان واحد، باللغة التي يقرأها الزبون.',
    'landing.about.title': 'من نحن',
    'landing.about.body': 'بي إن ستور هي هذه المنصة. يفتح التاجر متجره، يختار باقة ويبيع. يطلب الزبون، يدفع عند الاستلام أو بالتحويل، ويتابع طلبه. المتجر بالعربية والفرنسية والتونسية والإنجليزية.',
    'landing.about.merchantTitle': 'التاجر',
    'landing.about.merchant': 'يفتح التاجر متجره، يختار باقة ويبيع.',
    'landing.about.customerTitle': 'الزبون',
    'landing.about.customer': 'يطلب الزبون، يدفع عند الاستلام أو بالتحويل، ويتابع طلبه.',
    'landing.about.languagesTitle': 'أربع لغات',
    'landing.about.languages': 'المتجر بالعربية والفرنسية والتونسية والإنجليزية.',
    'landing.contact.title': 'اتصل بنا',
    'landing.contact.body': 'سؤال عن باقة أو متجر: راسلنا. التاجر الذي يملك متجرًا يسجّل الدخول.',
    'landing.contact.write': 'راسلنا',
    'landing.legal.title': 'السياسات',
    'landing.legal.termsBody': 'يختار التاجر باقة، ثم يستخدم بي إن ستور لمتجر واحد. السعر والفترة التجريبية هما المعروضان في هذه الصفحة.',
    'landing.legal.privacyBody': 'نستخدم بيانات دخول التاجر لتشغيل متجره، وتفاصيل الطلب لتوصيله. لا نبيع هذه البيانات.',
    'landing.legal.addressLabel': 'عنوان السياسة',
    'landing.footer.product': 'المنتج',
    'landing.place': 'تونس',
    'admin.setup.title': 'إعداد متجرك',
    'admin.setup.progress': 'الخطوة {current} من {total}',
    'admin.setup.steps': 'الخطوات',
    'admin.setup.done': 'تمّ',
    'admin.setup.todo': 'لم يكتمل',
    'admin.setup.optional': 'اختياري',
    'admin.setup.required': 'إلزامي',
    'admin.setup.skip': 'تخطّي هذه الخطوة',
    'admin.setup.continue': 'متابعة',
    'admin.setup.saveContinue': 'حفظ ومتابعة',
    'admin.setup.banner': 'هذا المتجر غير منشور بعد: لا يمكن للزبائن رؤيته.',
    'admin.setup.finish': 'إكمال الإعداد',
    'admin.setup.step.plan': 'الباقة',
    'admin.setup.step.contact': 'معلومات الاتصال',
    'admin.setup.step.legal': 'المعلومات القانونية',
    'admin.setup.step.delivery': 'التوصيل والدفع',
    'admin.setup.step.products': 'المنتجات',
    'admin.setup.step.publish': 'النشر',
    'admin.setup.plan.title': 'اختر باقتك',
    'admin.setup.plan.none': 'لا توجد باقة للاختيار حاليًا: تابع.',
    'admin.setup.plan.free': 'مجانية',
    'admin.setup.plan.trial': 'فترة تجريبية مجانية: {days, plural, zero {# يوم} one {يوم واحد} two {يومان} few {# أيام} many {# يومًا} other {# يوم}}',
    'admin.setup.plan.limits': 'المنتجات: {products} · أعضاء الفريق: {staff}',
    'admin.setup.plan.unlimited': 'غير محدود',
    'admin.setup.plan.locked': 'المتجر منشور أو مدفوع مسبقًا: تواصل مع beinstore لتغيير الباقة.',
    'admin.setup.contact.title': 'كيف يتواصل معك الزبائن',
    'admin.setup.contact.intro': 'تظهر أسفل كل صفحة من صفحات متجرك.',
    'admin.setup.contact.phone': 'الهاتف',
    'admin.setup.contact.email': 'البريد الإلكتروني للتواصل',
    'admin.setup.contact.governorate': 'الولاية',
    'admin.setup.contact.choose': 'اختر…',
    'admin.setup.contact.address': 'العنوان (اختياري)',
    'admin.setup.contact.governorateMissing': 'اختر ولايتك.',
    'admin.setup.legal.title': 'معلوماتك القانونية',
    'admin.setup.legal.intro': 'تُطبع على الفواتير التي تسلّمها لزبائنك.',
    'admin.setup.legal.name': 'الاسم القانوني ({language})',
    'admin.setup.legal.address': 'عنوان المقر ({language})',
    'admin.setup.legal.taxId': 'المعرّف الجبائي',
    'admin.setup.legal.taxIdHint': 'اختياري إذا لم تكن مسجّلًا.',
    'admin.setup.legal.more': 'كل إعدادات الفوترة',
    'admin.setup.delivery.title': 'كيف يدفع زبائنك ويستلمون طلباتهم',
    'admin.setup.delivery.intro': 'يلزم وسيلة دفع واحدة وطريقة توصيل واحدة على الأقل لاستقبال الطلبات.',
    'admin.setup.delivery.incomplete': 'اختر وسيلة دفع واحدة على الأقل، والاستلام من المتجر أو مناطق توصيل.',
    'admin.setup.delivery.bankInstructions': 'تعليمات التحويل البنكي',
    'admin.setup.delivery.shipping': 'التوصيل إلى المنزل',
    'admin.setup.delivery.zones': '{count, plural, =0 {لا توجد مناطق توصيل بعد.} one {منطقة توصيل واحدة.} two {منطقتا توصيل.} few {# مناطق توصيل.} many {# منطقة توصيل.} other {# منطقة توصيل.}}',
    'admin.setup.delivery.zonesLink': 'تحديد مناطق التوصيل وأسعارها حسب الولاية',
    'admin.setup.delivery.pickupAddress': 'عنوان الاستلام',
    'admin.setup.products.title': 'أضف منتجاتك الأولى',
    'admin.setup.products.intro': 'يلزم منتج واحد معروض للبيع على الأقل، بسعر ومخزون، للنشر.',
    'admin.setup.products.ready': 'لديك منتج جاهز للبيع.',
    'admin.setup.products.added': 'المنتجات المضافة',
    'admin.setup.products.form': 'منتج جديد',
    'admin.setup.products.name': 'الاسم',
    'admin.setup.products.price': 'السعر (د.ت)',
    'admin.setup.products.stock': 'الكمية في المخزون',
    'admin.setup.products.photo': 'صورة (اختياري)',
    'admin.setup.products.add': 'إضافة المنتج',
    'admin.setup.products.more': 'المحرّر الكامل للمنتجات',
    'admin.setup.products.invalid': 'أدخل اسمًا وسعرًا أكبر من صفر.',
    'admin.setup.publish.title': 'انشر متجرك',
    'admin.setup.publish.intro': 'تحقّق منه عبر المعاينة، ثم انشره: سيتمكّن الزبائن من زيارته والطلب.',
    'admin.setup.publish.missing': '{count, plural, one {خطوة إلزامية واحدة لم تكتمل.} two {خطوتان إلزاميتان لم تكتملا.} few {# خطوات إلزامية لم تكتمل.} many {# خطوة إلزامية لم تكتمل.} other {# خطوة إلزامية لم تكتمل.}}',
    'admin.setup.publish.preview': 'معاينة المتجر',
    'admin.setup.publish.action': 'نشر متجري',
    'admin.setup.publish.online': 'متجرك متاح الآن على الإنترنت.',
    'admin.setup.publish.toStore': 'الذهاب إلى لوحة المتجر',
    'admin.setup.publish.policies': 'أنت البائع. السلع المحظورة غير مسموحة. يمكن لـ beinstore إخفاء عرض أو إيقاف المتجر.',
    'admin.setup.publish.accept': 'قرأت وأقبل شروط الاستخدام وسياسة الخصوصية',
    'admin.billing.paymentInstructions': 'طريقة الدفع',
    'admin.operator.plan.offered': 'التسجيل',
    'admin.operator.plan.offeredHint': 'معروضة على التجّار الجدد في معالج الإعداد',
    'admin.operator.set.paymentInstructionsIn': 'تعليمات الدفع للتجّار ({language})',
    'admin.operator.set.paymentInstructionsHint': 'مثلًا المعطيات البنكية لـ beinstore. تظهر في خطوة الباقة وصفحة الاشتراك.',
    'admin.operator.set.requiredSteps': 'الخطوات الإلزامية قبل نشر متجر جديد',
    'admin.error.onboarding-incomplete': 'بعض الخطوات الإلزامية لم تكتمل بعد.',
    'admin.error.terms-not-accepted': 'اقبل شروط الاستخدام قبل النشر.',
    'storefront.contact': 'اتصل بنا',
    'admin.error.operator-account': 'هذا حساب مشغّل للمنصة. سجّل الدخول من وحدة تحكم المشغّل.',
    'admin.error.merchant-account': 'هذا الحساب مرتبط بمتاجر. يحتاج مشغّلو المنصة إلى حساب مخصّص.',
    'admin.operator.search': 'البحث عن متجر',
    'admin.operator.noStores': 'لا توجد متاجر.',
    'admin.operator.stores.intro': 'كل متجر وباقته الحالية: آخر دفعة، التجديد والموعد النهائي. بحث وتصفية وترتيب.',
    'admin.operator.planFilter': 'الباقة',
    'admin.operator.plan.any': 'كل الباقات',
    'admin.operator.stateFilter': 'الاشتراك',
    'admin.operator.state.any': 'كل الحالات',
    'admin.operator.renew': 'التجديد',
    'admin.operator.deadline': 'الموعد النهائي',
    'admin.operator.lastPayment': 'آخر دفعة',
    'admin.operator.noPayment': 'لا يوجد',
    'admin.operator.noPlan': 'بدون باقة',
    'admin.operator.stateShort.none': 'بدون اشتراك',
    'admin.operator.stateShort.free': 'مجاني',
    'admin.operator.stateShort.trialing': 'تجربة',
    'admin.operator.stateShort.active': 'محيّن',
    'admin.operator.stateShort.grace': 'متأخر',
    'admin.operator.stateShort.restricted': 'مقيّد',
    'admin.operator.plan.new': 'باقة جديدة',
    'admin.operator.plan.edit': 'تعديل {code}',
    'admin.operator.plan.code': 'الرمز',
    'admin.operator.plan.nameIn': 'الاسم بـ{language}',
    'admin.operator.plan.price': 'السعر لكل فترة (د.ت)',
    'admin.operator.plan.period': 'الفترة',
    'admin.operator.plan.months': '{count, plural, zero {# شهر} one {شهر} two {شهران} few {# أشهر} many {# شهرًا} other {# شهر}}',
    'admin.operator.plan.trialDays': 'أيام التجربة المجانية',
    'admin.operator.plan.graceDays': 'أيام الإمهال بعد تاريخ الاستحقاق',
    'admin.operator.plan.maxProducts': 'أقصى عدد للمنتجات (فارغ = غير محدود)',
    'admin.operator.plan.maxStaff': 'أقصى عدد لأعضاء الفريق (فارغ = غير محدود)',
    'admin.operator.plan.maxDomains': 'أقصى عدد للنطاقات الخاصة (فارغ = غير محدود)',
    'admin.operator.plan.active': 'مقترح للمتاجر',
    'admin.operator.plan.create': 'إنشاء الباقة',
    'admin.operator.plan.saved': 'تم حفظ الباقة.',
    'admin.operator.plan.error': 'تحقق من الرمز (فريد) والاسم والسعر والقيم.',
    'admin.operator.plan.empty': 'لا توجد باقات بعد.',
    'admin.operator.plan.subscribers': 'المتاجر المشتركة',
    'admin.operator.plan.subscriberCount': '{count, plural, zero {# متجر} one {متجر} two {متجران} few {# متاجر} many {# متجرًا} other {# متجر}}',
    'admin.operator.plan.delete': 'حذف هذه الباقة',
    'admin.operator.plan.confirmDelete': 'تأكيد حذف الباقة',
    'admin.operator.plan.deleted': 'تم حذف الباقة.',
    'admin.operator.plan.cannotDelete.subscribers': 'لا تزال متاجر على هذه الباقة. انقلها إلى باقة أخرى أولاً.',
    'admin.operator.plan.cannotDelete.payments': 'سُجّلت دفعات على هذه الباقة. أزلها من العرض بدل حذفها.',
    'admin.operator.plan.cannotDelete.default': 'هذه باقة المتاجر الجديدة. غيّرها في إعدادات الفوترة أولاً.',
    'admin.operator.set.legalNameIn': 'الاسم القانوني لـ beinstore ({language})',
    'admin.operator.set.addressIn': 'عنوان beinstore ({language})',
    'admin.operator.set.taxId': 'المعرف الجبائي لـ beinstore (اختياري)',
    'admin.operator.set.footerIn': 'تذييل الفاتورة ({language}، اختياري)',
    'admin.operator.set.prefix': 'بادئة أرقام الفواتير',
    'admin.operator.set.vatRate': 'نسبة الأداء على القيمة المضافة بالمائة (فارغ = بدون)',
    'admin.operator.set.pricesIncludeVat': 'أسعار الباقات تشمل الأداء على القيمة المضافة',
    'admin.operator.set.defaultPlan': 'باقة المتاجر الجديدة',
    'admin.operator.set.noDefault': 'لا شيء (بدون اشتراك)',
    'admin.operator.set.saved': 'تم حفظ الإعدادات.',
    'admin.operator.assign': 'تطبيق الباقة',
    'admin.operator.assigned': 'تم تطبيق الباقة.',
    'admin.operator.payment': 'تسجيل دفعة',
    'admin.operator.periods': 'عدد الفترات',
    'admin.operator.amount': 'المبلغ (د.ت، فارغ = السعر × الفترات)',
    'admin.operator.method': 'طريقة الدفع',
    'admin.operator.method.bank_transfer': 'تحويل بنكي',
    'admin.operator.method.cash': 'نقدًا',
    'admin.operator.method.other': 'أخرى',
    'admin.operator.reference': 'المرجع (اختياري)',
    'admin.operator.receivedAt': 'تاريخ الاستلام',
    'admin.operator.invoiceLanguage': 'لغة الفاتورة',
    'admin.operator.paid': 'تم تسجيل الدفعة وإصدار الفاتورة.',
    'admin.operator.payments': 'المدفوعات',
    'admin.operator.noPayments': 'لا توجد مدفوعات.',
    'admin.operator.paymentLine': '{date} — {amount} — {periods, plural, zero {# فترة} one {فترة} two {فترتان} few {# فترات} many {# فترة} other {# فترة}} ({from} → {to})',
    'admin.operator.error.settings': 'أدخل أولًا الاسم القانوني وعنوان beinstore في إعدادات الفوترة.',
    'admin.operator.error.noPlan': 'طبّق أولًا باقة على هذا المتجر.',
    'email.shopperCode.subject': 'رمز {store}: {code}',
    'email.shopperCode.heading': 'رمز الدخول الخاص بك',
    'email.shopperCode.intro': 'استخدم هذا الرمز لفتح حسابك لدى {store}:',
    'email.shopperCode.expiry': 'تنتهي صلاحيته بعد {minutes, plural, zero {# دقيقة} one {دقيقة واحدة} two {دقيقتين} few {# دقائق} many {# دقيقة} other {# دقيقة}} ولا يمكن استخدامه إلا مرة واحدة.',
    'email.shopperCode.ignore': 'إذا لم تطلب هذا الرمز فتجاهل هذه الرسالة: لا يمكن لأحد تسجيل الدخول بدونه.',
    'storefront.account.nav': 'حسابي',
    'storefront.account.signIn': 'تسجيل الدخول',
    'storefront.account.title': 'حسابي',
    'storefront.account.orders': 'طلباتي',
    'storefront.account.addresses': 'عناويني',
    'storefront.account.profile': 'بياناتي',
    'storefront.account.signOut': 'تسجيل الخروج',
    'storefront.account.phone': 'الهاتف',
    'storefront.account.email': 'البريد الإلكتروني',
    'storefront.account.name': 'الاسم واللقب',
    'storefront.account.sendCode': 'إرسال رمز',
    'storefront.account.code': 'الرمز الوارد في البريد',
    'storefront.account.verify': 'متابعة',
    'storefront.account.sent': 'إذا كان هذا الرقم يستطيع استلام رمز، فقد أُرسل بالبريد الإلكتروني.',
    'storefront.account.invalidCode': 'الرمز غير صحيح أو انتهت صلاحيته.',
    'storefront.account.save': 'حفظ',
    'storefront.account.saved': 'تم الحفظ.',
    'storefront.account.emailChange': 'تغيير البريد',
    'storefront.account.emailHint': 'يُرسل رمز إلى العنوان الجديد.',
    'storefront.account.noOrders': 'لا توجد طلبات بعد.',
    'storefront.account.addAddress': 'إضافة عنوان',
    'storefront.account.saveAddress': 'حفظ العنوان',
    'storefront.account.removeAddress': 'حذف',
    'storefront.account.defaultAddress': 'العنوان الافتراضي',
    'storefront.account.makeDefault': 'استخدامه افتراضيًا',
    'storefront.account.addressLimit': 'عشرة عناوين على الأكثر.',
    'storefront.account.cancelOrder': 'إلغاء هذا الطلب',
    'storefront.account.returnRequest': 'طلب إرجاع',
    'storefront.account.returnMessage': 'ماذا تريد إرجاعه؟',
    'storefront.account.returnSend': 'إرسال الطلب',
    'storefront.account.returnStatus.requested': 'أُرسل الطلب وبانتظار المتجر',
    'storefront.account.returnStatus.accepted': 'تم قبول الإرجاع',
    'storefront.account.returnStatus.declined': 'رُفض الطلب',
    'storefront.account.cancelClosed': 'لم يعد بالإمكان إلغاء هذا الطلب.',
    'storefront.account.phoneLocked': 'رقم الهاتف لا يتغير.',
    'storefront.account.newAccount': 'أول زيارة: أدخل أيضًا اسمك وبريدك.',
    'storefront.account.back': 'العودة إلى طلباتي',
    'storefront.account.cancelled': 'تم إلغاء طلبك.',
    'storefront.account.returnSent': 'أُرسل طلبك.',
    'storefront.account.declineNote': 'ملاحظة المتجر: {note}',
    'storefront.account.error': 'لم تنجح هذه العملية. أعد المحاولة.',
    'storefront.account.ordered': 'تاريخ الطلب',
    'storefront.account.payment': 'الدفع',
    'storefront.account.delivery': 'التوصيل',
    'storefront.account.deliveryDate': 'تاريخ التسليم',
    'storefront.account.plannedDelivery': 'التسليم المتوقع',
    'storefront.account.notDelivered': 'لم يُسلَّم بعد',
    'storefront.account.notScheduled': 'لم يُحدد بعد',
    'storefront.account.homeDelivery': 'توصيل إلى المنزل — {place}',
    'storefront.account.pickup': 'استلام من المتجر',
    'storefront.account.track': 'متابعة الطلب',
    'storefront.account.step.placed': 'تم الاستلام',
    'storefront.account.step.confirmed': 'مؤكد',
    'storefront.account.step.shipped': 'تم الشحن',
    'storefront.account.step.delivered': 'تم التسليم',
    'storefront.account.step.cancelled': 'ملغى',
    'storefront.account.step.returned': 'مُرجع',
    'storefront.account.items': 'السلع',
    'storefront.account.payment.pending': 'قيد الانتظار',
    'storefront.account.payment.paid': 'مدفوع',
    'storefront.account.payment.refunded': 'مُسترَد',
    'storefront.account.returnStep.reason': 'السبب',
    'storefront.account.returnStep.items': 'السلع',
    'storefront.account.returnStep.details': 'وضّح للمتجر',
    'storefront.account.returnReason.damaged': 'تالف أو غير مطابق',
    'storefront.account.returnReason.wrong': 'سلعة خاطئة',
    'storefront.account.returnReason.mind': 'غيّرت رأيي',
    'storefront.account.returnReason.other': 'سبب آخر',
    'storefront.account.returnWhole': 'الطلب كله',
    'storefront.account.returnReasonLabel': 'السبب',
    'storefront.account.returnItemsLabel': 'السلع',
    'storefront.account.commentTitle': 'رسالة عن هذا الطلب',
    'storefront.account.commentHint': 'يراها المتجر فقط. لا تُنشر.',
    'storefront.account.commentSend': 'إرسال الرسالة',
    'storefront.account.commentSent': 'أُرسلت رسالتك إلى المتجر.',
    'admin.order.returnRequest': 'طلب الإرجاع',
    'admin.order.returnRequest.none': 'لا يوجد طلب إرجاع.',
    'admin.order.returnRequest.acceptHint': 'تسجيل الإرجاع يقبل هذا الطلب.',
    'admin.order.returnRequest.decline': 'رفض الطلب',
    'admin.order.returnRequest.declineNote': 'سبب الرفض',
    'admin.order.returnRequest.message': 'رسالة الزبون',
    'admin.order.returnRequest.status.requested': 'في الانتظار',
    'admin.order.returnRequest.status.accepted': 'مقبول',
    'admin.order.returnRequest.status.declined': 'مرفوض',
};
//# sourceMappingURL=ar.js.map